/**
 * File generated by js-routes 2.2.8
 * Based on Rails 8.0.3 routes of AlumniConnect::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /ably/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ably_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ably"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/invitation/accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_backoffice_simple_admin_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/:venture_id/team_members/:id/accept(.:format)
 * @param {any} topic_id
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_topics_topic_venture_team_member_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:venture_id/team_members/:id/accept(.:format)
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_venture_team_member_path = /*#__PURE__*/ __jsr.r({"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/saml/acs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acs_backoffice_admins_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"acs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/saml/acs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acs_backoffice_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"acs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /saml/acs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acs_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"acs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/activate_users/activate(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_backoffice_network_activate_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"activate_users"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/add_new_locale(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_new_locale_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_new_locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/add_new_locale(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_new_locale_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_new_locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/add_new_locale(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_new_locale_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_new_locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/user_lists/:id/add_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_users_private_backoffice_networks_user_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/admin_seats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_seats_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin_seats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/advanced_options(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const advanced_options_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"advanced_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/branding/advanced_theming(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const advanced_theming_backoffice_network_branding_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"advanced_theming"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/aggregated_reports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aggregated_reports_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"aggregated_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/ai-global-settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_global_settings_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai-global-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/analytics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_backoffice_network_letter_emailings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payments/analytics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_backoffice_network_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/analytics(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/analytics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_backoffice_network_recurring_emailing_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/payments/analytics(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_backoffice_network_topic_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/analytics(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/analytics(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_backoffice_network_topic_recurring_emailing_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/surveys/forms/:id/analytics(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_user_surveys_form_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/reactions/emoji_definitions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_admin_v4_reactions_emoji_definition_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"reactions"],[2,[7,"/"],[2,[6,"emoji_definitions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/reactions/emoji_definitions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_admin_v4_reactions_emoji_definitions_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"reactions"],[2,[7,"/"],[2,[6,"emoji_definitions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/topics/:topic_id/whitelabels/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_admin_v4_topic_whitelabel_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/topics/:topic_id/whitelabels(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_admin_v4_topic_whitelabels_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"whitelabels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/user_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_admin_v4_user_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/user_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_admin_v4_user_lists_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/whitelabels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_admin_v4_whitelabel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/whitelabels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_admin_v4_whitelabels_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"whitelabels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/auth/v1/authenticated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_auth_v1_authenticated_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"authenticated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/auth/v1/refresh_admin_tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_auth_v1_refresh_admin_tokens_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"refresh_admin_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/auth/v1/refresh_tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_auth_v1_refresh_tokens_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"refresh_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/auth/v1/unauthenticated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_auth_v1_unauthenticated_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"unauthenticated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/user/v3/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_user_v3_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/user/v3/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_user_v3_comments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/user/v3/content/recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_user_v3_content_recommendations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[6,"recommendations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/user/v3/me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_user_v3_me_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/user/v3/reactions/emojis/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_user_v3_reactions_emoji_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"reactions"],[2,[7,"/"],[2,[6,"emojis"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/user/v3/reactions/emojis(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_user_v3_reactions_emojis_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"reactions"],[2,[7,"/"],[2,[6,"emojis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_oauth_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /app/config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_config_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"app"],[2,[7,"/"],[2,[6,"config"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session_info/app_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_pages_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"app_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:id/approve(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/:id/approve(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/archive(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/archive(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/archive(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/moderation/reported_contents/:id/archive_report(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_report_backoffice_network_moderation_reported_content_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"reported_contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /articles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const articles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/roles/assign(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_backoffice_network_roles_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_funds/:id/associated_campaigns_details(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associated_campaigns_details_backoffice_network_donation_fund_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_funds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associated_campaigns_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/associated_funds_details(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associated_funds_details_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associated_funds_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/attach_file(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_file_backoffice_network_uploads_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"attach_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /uploads/attach_file(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_file_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"attach_file"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/attach_image(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_image_backoffice_network_uploads_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"attach_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /uploads/attach_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_image_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"attach_image"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/responses/attend(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attend_backoffice_network_event_responses_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[6,"attend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/responses/attend(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attend_backoffice_network_topic_event_responses_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[6,"attend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events/:id/attend(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attend_user_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/responses/attend(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attend_user_network_event_responses_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[6,"attend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events/attendees(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attendees_user_events_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/attending(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attending_user_network_events_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"attending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth_code_flow/admin_login_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_code_flow_admin_login_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth_code_flow"],[2,[7,"/"],[2,[6,"admin_login_check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth_code_flow/connect_url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_code_flow_connect_url_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth_code_flow"],[2,[7,"/"],[2,[6,"connect_url"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth_code_flow/consent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_code_flow_consent_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth_code_flow"],[2,[7,"/"],[2,[6,"consent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth_code_flow/login_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_code_flow_login_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth_code_flow"],[2,[7,"/"],[2,[6,"login_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth_code_flow/oauth_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_code_flow_oauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth_code_flow"],[2,[7,"/"],[2,[6,"oauth_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth_code_flow/user_login_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_code_flow_user_login_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth_code_flow"],[2,[7,"/"],[2,[6,"user_login_check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/authors(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authors_backoffice_network_recurring_emailing_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[6,"authors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/_elasticsearch/reindex(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice__elasticsearch_reindex_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"_elasticsearch"],[2,[7,"/"],[2,[6,"reindex"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admin_notices/messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_admin_notices_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admin_notices"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admin_notices/messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_admin_notices_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admin_notices"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/saml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_admins_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/communications/:communication_id/recipients(.:format)
 * @param {any} communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_api_communication_recipients_path = /*#__PURE__*/ __jsr.r({"communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"communication_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/community/kpi(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_api_community_kpi_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"kpi"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/community/quota(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_api_community_quota_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"quota"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/community/user_fields_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_api_community_user_fields_config_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"user_fields_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/community/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_api_community_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/network_events/:event_id/emails/:id(.:format)
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_api_network_events_email_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/network_events/:event_id/email_campaigns(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_api_network_events_email_campaigns_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"email_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/network_events/:event_id/emails(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_api_network_events_emails_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/app_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_app_configuration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"app_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/exports/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_cancel_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/currencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_currencies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"currencies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/currencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_currency_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"currencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_embed_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/exports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/exports/:id/progress(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_export_progress_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/exports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_exports_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /feature_flag_all_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_feature_flag_all_flags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flag_all_flags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feature_flag_is_enabled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_feature_flag_is_enabled_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flag_is_enabled"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feature_flag_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_feature_flag_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flag_settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feature_flag_test_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_feature_flag_test_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flag_test_page"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/i18n_tests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_i18n_tests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"i18n_tests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/log_as/become_user/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_log_as_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"become_user"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/log_as/admin_duallog_as_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_log_as_admin_duallog_as_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"admin_duallog_as_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/log_as/become_simple_admin/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_log_as_become_simple_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"become_simple_admin"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/log_as/become_user/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_log_as_become_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"become_user"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/log_as/end(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_log_as_end_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"end"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/log_as/user_duallog_as_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_log_as_user_duallog_as_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"user_duallog_as_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/log_as/user_duallog_as_group_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_log_as_user_duallog_as_group_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"user_duallog_as_group_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/maintenance_tasks
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_maintenance_tasks_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"maintenance_tasks"]]]]);

/**
 * Generates rails route to
 * /backoffice/maintenance_tasks/tasks/:task_id/runs/:id/pause
 * @param {any} task_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_maintenance_tasks_pause_task_run_path = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"id":{"r":true}}, [2,[2,[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"maintenance_tasks"]]]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"pause"]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/maintenance_tasks/tasks/:task_id/runs/:id/cancel
 * @param {any} task_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_maintenance_tasks_cancel_task_run_path = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"id":{"r":true}}, [2,[2,[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"maintenance_tasks"]]]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/maintenance_tasks/tasks/:task_id/runs/:id/resume
 * @param {any} task_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_maintenance_tasks_resume_task_run_path = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"id":{"r":true}}, [2,[2,[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"maintenance_tasks"]]]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"resume"]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/maintenance_tasks/tasks/:task_id/runs
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_maintenance_tasks_task_runs_path = /*#__PURE__*/ __jsr.r({"task_id":{"r":true}}, [2,[2,[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"maintenance_tasks"]]]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[6,"runs"]]]]]]);

/**
 * Generates rails route to
 * /backoffice/maintenance_tasks/tasks
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_maintenance_tasks_tasks_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"maintenance_tasks"]]]],[7,"/"]],[6,"tasks"]]);

/**
 * Generates rails route to
 * /backoffice/maintenance_tasks/tasks/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_maintenance_tasks_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[2,[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"maintenance_tasks"]]]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[3,"id"]]]]);

/**
 * Generates rails route to
 * /backoffice/maintenance_tasks/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_maintenance_tasks_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"maintenance_tasks"]]]],[7,"/"]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ably/token(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_ably_token_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ably"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/account_details(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_account_details_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"account_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/activate_users/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_activate_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"activate_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/activate_users(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_activate_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"activate_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/activation_form/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_activation_form_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"activation_form"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/activation_form/user_fields_configs(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_activation_form_user_fields_configs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"activation_form"],[2,[7,"/"],[2,[6,"user_fields_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/additional_code(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_additional_code_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"additional_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/:admin_id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} admin_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admin_duplicate_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"admin_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"admin_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/:admin_id/languages(.:format)
 * @param {any} network_id
 * @param {any} admin_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admin_languages_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"admin_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"admin_id"],[2,[7,"/"],[2,[6,"languages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admin_notification_emails/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admin_notification_email_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admin_notification_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admin_notification_emails(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admin_notification_emails_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admin_notification_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/:admin_id/send_invitation(.:format)
 * @param {any} network_id
 * @param {any} admin_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admin_send_invitation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"admin_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"admin_id"],[2,[7,"/"],[2,[6,"send_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admins_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/data_access/roles/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admins_data_access_role_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"data_access"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/data_access/roles(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admins_data_access_roles_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"data_access"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/imports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admins_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/imports/:import_id/logs(.:format)
 * @param {any} network_id
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admins_import_logs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/imports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_admins_imports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/apis/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_api_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/apis(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_apis_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"apis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/apple/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_apple_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"apple"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/apple(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_apple_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"apple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_approval_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_approvals_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_approvals_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/exports/:approvals_export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} approvals_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_approvals_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"approvals_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"approvals_export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/exports/:approvals_export_id/download(.:format)
 * @param {any} network_id
 * @param {any} approvals_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_approvals_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"approvals_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"approvals_export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_approvals_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/badges/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_badge_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/badges(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_badges_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"badges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_billing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/charges/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_billing_charge_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/charges(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_billing_charges_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"charges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/invoices/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_billing_invoice_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/invoices(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_billing_invoices_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/subscriptions/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_billing_subscription_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/subscriptions(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_billing_subscriptions_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_bizopp_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/customizable_attributes(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_bizopp_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/branding(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_branding_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_configurations(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_builder_configurations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_builder_template_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/:builder_template_id/export(.:format)
 * @param {any} network_id
 * @param {any} builder_template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_builder_template_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"builder_template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"builder_template_id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/:builder_template_id/import(.:format)
 * @param {any} network_id
 * @param {any} builder_template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_builder_template_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"builder_template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"builder_template_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_builder_templates_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_companies_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_company_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/:company_id/experiences(.:format)
 * @param {any} network_id
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_company_experiences_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"experiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/:company_id/search_jobs(.:format)
 * @param {any} network_id
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_company_search_jobs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"search_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/experiences/imports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_experiences_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"experiences"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/experiences/imports/:import_id/logs(.:format)
 * @param {any} network_id
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_experiences_import_logs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"experiences"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/experiences/imports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_experiences_imports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"experiences"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/imports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/imports/:import_id/logs(.:format)
 * @param {any} network_id
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_import_logs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/imports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_companies_imports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/config/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_config_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"config"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/configs_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_configs_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"configs_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/network_configurations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_configuration_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"network_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/cookies/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_cookie_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"cookies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/cookies(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_cookies_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"cookies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/currencies(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_currencies_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"currencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/currencies/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_currency_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"currencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/customizable_attributes(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/customizable_attributes/groups/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_customizable_attributes_group_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/customizable_attributes/groups(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_customizable_attributes_groups_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_data_management_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management/exports/:export_id/cancel_export(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_data_management_export_cancel_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management/exports/:export_id/download_xlsx_file(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_data_management_export_download_xlsx_file_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download_xlsx_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management/exports/:export_id/status(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_data_management_export_status_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_data_management_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/digest(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_digest_configuration_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"digest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donations/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/customizable_attributes(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/exports(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/orders/:order_id/matchings(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_order_matchings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"matchings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/orders(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaign_orders_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_campaigns_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_customizable_attributes(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_funds/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_fund_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_funds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_funds(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_funds_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_funds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_user_fields_configs(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_user_fields_configs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_user_fields_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donations/whitelabels/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_whitelabel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donations/whitelabels(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donation_whitelabel_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"whitelabels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donations(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_donations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/educations/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_educations_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"educations"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/educations/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_educations_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"educations"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/educations/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_educations_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"educations"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/educations/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_educations_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"educations"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_email_analytic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_email_analytics_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_domains/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_email_domain_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_domains(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_email_domains_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_email_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/emailing_analytics/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_emailing_analytic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"emailing_analytics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/emailing_analytics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_emailing_analytics_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"emailing_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/engagement_scoring/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_engagement_scoring_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/engagement_scoring/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_engagement_scoring_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/engagement_scoring/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_engagement_scoring_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/engagement_scoring/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_engagement_scoring_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/engagement_scoring/scoring_points(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_engagement_scoring_scoring_points_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"scoring_points"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/addons/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/addons/:addon_id/update_images(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} addon_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_addon_update_images_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"addon_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"addon_id"],[2,[7,"/"],[2,[6,"update_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/addons(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_addons_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"addons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_attendee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/imports/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_attendees_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/imports/:import_id/logs(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_attendees_import_logs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/imports(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_attendees_imports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/booking/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_booking_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/customizable_attributes(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/donations/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/donations(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_donations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/exports(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_page_customizables_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/responses_exports/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_responses_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/responses_exports/:responses_export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} responses_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_responses_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"responses_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[2,[7,"/"],[2,[3,"responses_export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/responses_exports/:responses_export_id/download(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} responses_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_responses_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"responses_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[2,[7,"/"],[2,[3,"responses_export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/responses_exports(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_responses_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/tickets/:id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_ticket_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/tickets(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_event_tickets_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/external_api_integrations/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_external_api_integration_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"external_api_integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/external_api_integrations(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_external_api_integrations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"external_api_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/features/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_feature_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/feature_flags/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_feature_flag_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/feature_flags(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_feature_flags_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/features(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_features_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/feed_sources/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_feed_source_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"feed_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/feed_sources(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_feed_sources_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"feed_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/flash_messages/campaigns/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_flash_messages_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/flash_messages/campaigns/:campaign_id/confirmations(.:format)
 * @param {any} network_id
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_flash_messages_campaign_confirmations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"confirmations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/flash_messages/campaigns(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_flash_messages_campaigns_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/font(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_font_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"font"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_forums_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/imports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_forums_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/imports/:import_id/logs(.:format)
 * @param {any} network_id
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_forums_import_logs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/imports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_forums_imports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/network_categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_forums_network_categories_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"network_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/network_categories/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_forums_network_category_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"network_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/html_blocks/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_html_block_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"html_blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/invalid_records(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_invalid_records_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"invalid_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_item_url_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_item_urls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_journey_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_journeys_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/kinds/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_kind_configuration_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"kinds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/kinds(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_kind_configuration_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"kinds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/:id(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_letter_emailing_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_letter_emailings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/linkedin/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_linkedin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"linkedin"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/linkedin(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_linkedin_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"linkedin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/live_feed(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_live_feed_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"live_feed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/locales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_locales_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"locales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center/portfolios/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_portfolio_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"portfolios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center/portfolios(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_portfolios_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"portfolios"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/files/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_file_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/files/:file_id/move_to(.:format)
 * @param {any} network_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_file_move_to_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"move_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_folder_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/:folder_id/files(.:format)
 * @param {any} network_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_folder_files_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/:folder_id/folders(.:format)
 * @param {any} network_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_folder_folders_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/:folder_id/move_to(.:format)
 * @param {any} network_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_folder_move_to_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"move_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/:folder_id/tree(.:format)
 * @param {any} network_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_media_center_v2_folder_tree_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/addons/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_advanced_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/addons/:addon_id/update_images(.:format)
 * @param {any} network_id
 * @param {any} addon_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_advanced_addon_update_images_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"addon_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"addon_id"],[2,[7,"/"],[2,[6,"update_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/addons(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_advanced_addons_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/donations/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_advanced_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/donations(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_advanced_donations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/customizable_attributes(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/orders/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_orders_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/orders/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_orders_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/orders/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_orders_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/orders/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_orders_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/programmes(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_programme_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"programmes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/subscriptions/imports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_subscriptions_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/subscriptions/imports/:import_id/logs(.:format)
 * @param {any} network_id
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_subscriptions_import_logs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/subscriptions/imports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_subscriptions_imports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_type_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/:memberships_type_id/update_email(.:format)
 * @param {any} network_id
 * @param {any} memberships_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_type_update_email_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"memberships_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[3,"memberships_type_id"],[2,[7,"/"],[2,[6,"update_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_types_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/imports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_types_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/imports/:import_id/logs(.:format)
 * @param {any} network_id
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_types_import_logs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/imports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_types_imports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/user_fields_configs/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_user_fields_config_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"user_fields_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/user_fields_configs(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_memberships_user_fields_configs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"user_fields_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/mentorings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_mentorings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"mentorings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/can_be_a_mentee_users(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_can_be_a_mentee_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"can_be_a_mentee_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/can_be_a_mentor_users(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_can_be_a_mentor_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"can_be_a_mentor_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/duplicates(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_duplicates_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"duplicates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/emails/:id(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_email_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/emails(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_emails_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/mentee_customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_mentee_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentee_customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/mentee_customizable_attributes(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_mentee_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentee_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/mentee_profiles/:id(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_mentee_profile_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentee_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/mentee_profiles(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_mentee_profiles_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentee_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/mentor_customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_mentor_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentor_customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/mentor_customizable_attributes(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_mentor_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentor_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/mentor_profiles/:id(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_mentor_profile_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentor_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/mentor_profiles(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_mentor_profiles_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentor_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/page_customizables(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_page_customizables_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/relationships/:id(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_relationship_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/relationships(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_relationships_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"relationships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/relationships/bulks(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_program_relationships_bulks_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"bulks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mentorings_programs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/messaging/sendbird_apps(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_messaging_sendbird_apps_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"messaging"],[2,[7,"/"],[2,[6,"sendbird_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mobile_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mobile_app_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mobile_apps_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_push_notifications/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mobile_push_notification_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_push_notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_push_notifications(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_mobile_push_notifications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_push_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/moderation/reported_contents/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_moderation_reported_content_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"reported_contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/moderation/reported_contents(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_moderation_reported_contents_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"reported_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/module_store/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_module_store_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"module_store"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/module_store(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_module_store_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"module_store"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_network_categories_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_categories/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_network_category_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_emails/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_network_email_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_emails(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_network_emails_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_links/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_network_link_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_links(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_network_links_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/networks/communications/posts/categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_networks_communications_posts_categories_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/community_analytics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_omni_analytics_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"community_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_opportunities_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_opportunities_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/exports/:opportunities_export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} opportunities_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_opportunities_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"opportunities_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"opportunities_export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/exports/:opportunities_export_id/download(.:format)
 * @param {any} network_id
 * @param {any} opportunities_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_opportunities_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"opportunities_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"opportunities_export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_opportunities_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:opportunity_id/applicants(.:format)
 * @param {any} network_id
 * @param {any} opportunity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_opportunity_applicants_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"opportunity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"opportunity_id"],[2,[7,"/"],[2,[6,"applicants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/orbiit(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_orbiit_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"orbiit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/pages/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/attach_image_to_slider(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_attach_image_to_slider_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"attach_image_to_slider"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/duplicate_page(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_duplicate_page_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"duplicate_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/edit_slider_upload/:upload_id(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {any} upload_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_edit_slider_upload_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"upload_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"edit_slider_upload"],[2,[7,"/"],[2,[3,"upload_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/export(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/import(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/new_slider_upload(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_new_slider_upload_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"new_slider_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/sub_page_customizables/:id(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_sub_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"sub_page_customizables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/sub_page_customizables(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_sub_page_customizables_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"sub_page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/update_slide_upload/:upload_id(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {any} upload_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_update_slide_upload_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"upload_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"update_slide_upload"],[2,[7,"/"],[2,[3,"upload_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/update_slider_pictures_positions(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizable_update_slider_pictures_positions_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"update_slider_pictures_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_page_customizables_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/pages(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_pages_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/pages_categories_internals/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_pages_categories_internal_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"pages_categories_internals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/pages_categories_internals(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_pages_categories_internals_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"pages_categories_internals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/partners/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_partner_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/partners(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_partners_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payments/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_payment_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_accounts/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_payment_account_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_accounts/:payment_account_id/show_attached_purchasables(.:format)
 * @param {any} network_id
 * @param {any} payment_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_payment_account_show_attached_purchasables_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"payment_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_accounts"],[2,[7,"/"],[2,[3,"payment_account_id"],[2,[7,"/"],[2,[6,"show_attached_purchasables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_accounts(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_payment_accounts_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_history_receivers/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_payment_history_receiver_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_history_receivers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_history_receivers(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_payment_history_receivers_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_history_receivers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_notifications(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_payment_notifications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payments(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/people_directory(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_people_directory_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"people_directory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/portfolio/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_portfolio_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/portfolio(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_portfolio_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"portfolio"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/post_upload_publish(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_post_upload_publish_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"post_upload_publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/posts_rss_sources/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_posts_rss_source_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"posts_rss_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/posts_rss_sources(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_posts_rss_sources_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"posts_rss_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/promo_codes/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_promo_code_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/promo_codes(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_promo_codes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"promo_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/:id(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_recurring_emailing_communication_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_recurring_emailing_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/roles/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_role_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/roles(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_roles_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/signup_configuration(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_signup_configuration_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"signup_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/signup_form/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_signup_form_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"signup_form"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/signup_form/user_fields_configs(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_signup_form_user_fields_configs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"signup_form"],[2,[7,"/"],[2,[6,"user_fields_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/social_plugables/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_social_plugable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"social_plugables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/attendees(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_attendees_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/attendees/rsvp(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_attendees_rsvp_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"rsvp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/attendees/rsvp/export(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_attendees_rsvp_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"rsvp"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/attendees/tickets(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_attendees_tickets_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/attendees/tickets/bookings/create(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_attendees_tickets_bookings_create_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/attendees/tickets/bookings/edit/:booking_id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} booking_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_attendees_tickets_bookings_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"booking_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/attendees/tickets/export(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_attendees_tickets_bookings_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/attendees/tickets/bookings/import(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_attendees_tickets_bookings_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/communications(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/communications/campaigns(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_communications_campaigns_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/communications/cancellation(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_communications_cancellation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/communications/confirmation(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_communications_confirmation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/communications/reminders(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_communications_reminders_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/details(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_details_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/export/:exportId(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} exportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_export_status_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"exportId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[3,"exportId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/cancellation-policy(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_cancellation_policy_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"cancellation-policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/configuration(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_configuration_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/configuration/addons/create(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_configuration_addons_create_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/configuration/addons/edit/:addon_id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} addon_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_configuration_addons_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"addon_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"addon_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/configuration/tickets/create(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_configuration_create_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/configuration/donations/create(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_configuration_donations_create_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/configuration/donations/edit/:donation_id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} donation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_configuration_donations_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"donation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"donation_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/configuration/tickets/edit/:ticket_id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} ticket_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_configuration_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"ticket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"ticket_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/registration-form(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_registration_form_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"registration-form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/registration/success-page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_registration_success_page_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"success-page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/reports(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_reports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/version_log(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_version_log_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"version_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit_v2/visibility(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_events_visibility_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/communications(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/custom(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_custom_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/custom/mentee(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_custom_mentee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"mentee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/custom/mentor(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_custom_mentor_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"mentor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/matching(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_matching_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"matching"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/matching/mentee/:menteeId(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} menteeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_matching_mentee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"menteeId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"matching"],[2,[7,"/"],[2,[6,"mentee"],[2,[7,"/"],[2,[3,"menteeId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/matching/mentor/:mentorId(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} mentorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_matching_mentor_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"mentorId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"matching"],[2,[7,"/"],[2,[6,"mentor"],[2,[7,"/"],[2,[3,"mentorId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/mentees(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_mentees_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/mentees/:menteeId(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} menteeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_mentees_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"menteeId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentees"],[2,[7,"/"],[2,[3,"menteeId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/mentees/new(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_mentees_new_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/mentors(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_mentors_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/mentors/:mentorId(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} mentorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_mentors_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"mentorId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentors"],[2,[7,"/"],[2,[3,"mentorId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/mentors/new(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_mentors_new_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_new_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_new_program_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/relationships(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_relationships_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring/program/:id/general(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentoring_show_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"general"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentoring(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_mentorings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentoring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news_v2(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news_v2/categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_news_categories_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news_v2"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news_v2/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_news_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news_v2"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news_v2/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_news_new_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news_v2"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news_v2/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_news_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news_v2"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/people_directory/bookmarks(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_people_directory_bookmarks_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"people_directory"],[2,[7,"/"],[2,[6,"bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_events/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_spa_user_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sso_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso_admin/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sso_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso_admin"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso_admin(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sso_admin_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sso_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/storage_tests/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_storage_test_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"storage_tests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/storage_tests(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_storage_tests_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"storage_tests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sub_network_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/:sub_network_id/notify_users/:which(.:format)
 * @param {any} network_id
 * @param {any} sub_network_id
 * @param {any} which
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sub_network_notify_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"sub_network_id":{"r":true},"which":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[3,"sub_network_id"],[2,[7,"/"],[2,[6,"notify_users"],[2,[7,"/"],[2,[3,"which"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/:sub_network_id/users/:id(.:format)
 * @param {any} network_id
 * @param {any} sub_network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sub_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"sub_network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[3,"sub_network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/:sub_network_id/users(.:format)
 * @param {any} network_id
 * @param {any} sub_network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sub_network_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"sub_network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[3,"sub_network_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_sub_networks_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/surveys/forms/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_surveys_form_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/surveys/forms(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_surveys_forms_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/terms_and_policies(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_terms_and_policies_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"terms_and_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ticket_checkins/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_ticket_checkin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ticket_checkins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ticket_checkins(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_ticket_checkins_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ticket_checkins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/:admin_id/languages(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} admin_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_admin_languages_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"admin_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"admin_id"],[2,[7,"/"],[2,[6,"languages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_admins_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/approvals/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_approval_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/approvals(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_approvals_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/builder_templates/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_builder_template_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/builder_templates(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_builder_templates_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"builder_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/bulk_topic_followings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_bulk_topic_followings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"bulk_topic_followings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/customizable_attributes(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_engagement_scoring_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_engagement_scoring_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_engagement_scoring_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/exports(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_engagement_scoring_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/scoring_points(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_engagement_scoring_scoring_points_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"scoring_points"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_attendee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_attendees_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/exports(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/responses_exports/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_responses_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/responses_exports/:responses_export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} responses_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_responses_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"responses_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[2,[7,"/"],[2,[3,"responses_export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/responses_exports/:responses_export_id/download(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} responses_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_responses_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"responses_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[2,[7,"/"],[2,[3,"responses_export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/responses_exports(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_event_responses_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/features(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_features_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/followings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_followings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"followings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/forum(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_forum_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"forum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/html_blocks/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_html_block_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"html_blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_jobs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_letter_emailing_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_letter_emailings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_media_center_folder_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/:folder_id/files/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} folder_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_media_center_folder_file_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"folder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/:folder_id/files(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_media_center_folder_files_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_media_center_folders_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_member_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/member_requests(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_member_requests_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"member_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_members_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_members_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/exports/:members_export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} members_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_members_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"members_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"members_export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/exports/:members_export_id/download(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} members_export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_members_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"members_export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"members_export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/exports(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_members_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_membership_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/:membership_id/customizable_attributes/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} membership_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_membership_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"membership_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"membership_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/:membership_id/customizable_attributes(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} membership_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_membership_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"membership_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"membership_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/:membership_id/update_email(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} membership_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_membership_update_email_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"membership_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"membership_id"],[2,[7,"/"],[2,[6,"update_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/:membership_id/user_fields_configs/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} membership_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_membership_user_fields_config_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"membership_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"membership_id"],[2,[7,"/"],[2,[6,"user_fields_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/:membership_id/user_fields_configs(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} membership_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_membership_user_fields_configs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"membership_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"membership_id"],[2,[7,"/"],[2,[6,"user_fields_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/addons/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_advanced_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/addons/:addon_id/update_images(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} addon_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_advanced_addon_update_images_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"addon_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"addon_id"],[2,[7,"/"],[2,[6,"update_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/addons(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_advanced_addons_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/donations/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_advanced_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/donations(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_advanced_donations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/exports(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/orders/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_orders_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/orders/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_orders_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/orders/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_orders_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/orders/exports(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_memberships_orders_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:page_customizable_id/duplicate_page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_page_customizable_duplicate_page_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"duplicate_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:page_customizable_id/sub_page_customizables/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} page_customizable_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_page_customizable_sub_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"page_customizable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"sub_page_customizables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:page_customizable_id/sub_page_customizables(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_page_customizable_sub_page_customizables_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"sub_page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_page_customizables_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/payments/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_payment_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/payments(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_recurring_emailing_communication_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_recurring_emailing_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/rss_sources/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_rss_source_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"rss_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/rss_sources(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_rss_sources_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"rss_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/settings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/attendees(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_attendees_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/attendees/rsvp(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_attendees_rsvp_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"rsvp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/attendees/rsvp/export(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_attendees_rsvp_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"rsvp"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/attendees/tickets(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_attendees_tickets_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/attendees/tickets/bookings/create(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_attendees_tickets_bookings_create_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/attendees/tickets/bookings/edit/:booking_id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} booking_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_attendees_tickets_bookings_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"booking_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/attendees/tickets/export(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_attendees_tickets_bookings_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/communications(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/communications/campaigns(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_communications_campaigns_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/communications/cancellation(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_communications_cancellation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/communications/confirmation(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_communications_confirmation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/communications/reminders(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_communications_reminders_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/details(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_details_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/export/:exportId(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} exportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_export_status_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"exportId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[3,"exportId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/cancellation-policy(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_cancellation_policy_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"cancellation-policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/configuration(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_configuration_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/configuration/addons/create(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_configuration_addons_create_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/configuration/addons/edit/:addon_id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} addon_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_configuration_addons_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"addon_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"addon_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/configuration/tickets/create(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_configuration_create_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/configuration/donations/create(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_configuration_donations_create_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/configuration/donations/edit/:donation_id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} donation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_configuration_donations_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"donation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"donation_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/configuration/tickets/edit/:ticket_id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} ticket_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_configuration_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"ticket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"ticket_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/registration-form(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_registration_form_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"registration-form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/registration/success-page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_registration_success_page_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"success-page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/reports(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_reports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/version_log(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_version_log_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"version_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit_v2/visibility(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_events_visibility_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_v2"],[2,[7,"/"],[2,[6,"visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/communications(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/custom(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_custom_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/custom/mentee(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_custom_mentee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"mentee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/custom/mentor(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_custom_mentor_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"mentor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/matching(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_matching_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"matching"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/matching/mentee/:menteeId(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} menteeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_matching_mentee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"menteeId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"matching"],[2,[7,"/"],[2,[6,"mentee"],[2,[7,"/"],[2,[3,"menteeId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/matching/mentor/:mentorId(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} mentorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_matching_mentor_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"mentorId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"matching"],[2,[7,"/"],[2,[6,"mentor"],[2,[7,"/"],[2,[3,"mentorId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/mentees(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_mentees_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/mentees/:menteeId(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} menteeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_mentees_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"menteeId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentees"],[2,[7,"/"],[2,[3,"menteeId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/mentees/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_mentees_new_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/mentors(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_mentors_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/mentors/:mentorId(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {any} mentorId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_mentors_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"mentorId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentors"],[2,[7,"/"],[2,[3,"mentorId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/mentors/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_mentors_new_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_new_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_new_program_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/relationships(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_relationships_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/settings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring/program/:id/general(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentoring_show_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[6,"program"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"general"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/mentoring(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_mentorings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news_v2(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news_v2/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_news_edit_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news_v2"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news_v2/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_news_new_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news_v2"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news_v2/settings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_news_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news_v2"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/user_events/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_spa_user_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/users/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/users(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/ventures/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_venture_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/ventures(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_ventures_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/whitelabels/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_whitelabel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/whitelabels(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topic_whitelabels_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"whitelabels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics_categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_categories_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics_categories/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_category_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics_categories/:topics_category_id/bulk_orderings(.:format)
 * @param {any} network_id
 * @param {any} topics_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_category_bulk_orderings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topics_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics_categories"],[2,[7,"/"],[2,[3,"topics_category_id"],[2,[7,"/"],[2,[6,"bulk_orderings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/category_sets/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_category_set_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/category_sets/:category_set_id/add_category_to_set(.:format)
 * @param {any} network_id
 * @param {any} category_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_category_set_add_category_to_set_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"category_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[2,[7,"/"],[2,[3,"category_set_id"],[2,[7,"/"],[2,[6,"add_category_to_set"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/category_sets/:category_set_id/remove_category_from_set(.:format)
 * @param {any} network_id
 * @param {any} category_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_category_set_remove_category_from_set_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"category_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[2,[7,"/"],[2,[3,"category_set_id"],[2,[7,"/"],[2,[6,"remove_category_from_set"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/category_sets/:category_set_id/update_topic_category_position(.:format)
 * @param {any} network_id
 * @param {any} category_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_category_set_update_topic_category_position_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"category_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[2,[7,"/"],[2,[3,"category_set_id"],[2,[7,"/"],[2,[6,"update_topic_category_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/category_sets(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_category_sets_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/exports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/exports/:export_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_export_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/exports/:export_id/download(.:format)
 * @param {any} network_id
 * @param {any} export_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_export_download_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/imports/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/imports/:import_id/logs(.:format)
 * @param {any} network_id
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_import_logs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/imports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_topics_imports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/universal_tags/tags/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_universal_tags_tag_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"universal_tags"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/universal_tags/tags(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_universal_tags_tags_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"universal_tags"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_update_campaigns_campaigns_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_upload_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_uploads_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_activities(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_activities_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/authentications/:id(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_authentication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"authentications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_events/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_events/:user_event_id/event_responses(.:format)
 * @param {any} network_id
 * @param {any} user_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_event_event_responses_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[3,"user_event_id"],[2,[7,"/"],[2,[6,"event_responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_events(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_fields_configs/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_fields_config_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_fields_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_fields_configs(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_fields_configs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_fields_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_invitations(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_invitations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_lists/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_list_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_lists(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_lists_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions/:id(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_memberships_subscription_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions/:subscription_id/cancel(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_memberships_subscription_cancel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions/:subscription_id/manual_transactions/:id(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {any} subscription_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_memberships_subscription_manual_transaction_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"subscription_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"manual_transactions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions/:subscription_id/manual_transactions(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_memberships_subscription_manual_transactions_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"manual_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions/:subscription_id/renew(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_memberships_subscription_renew_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions/:subscription_id/terminate(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_memberships_subscription_terminate_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"terminate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_memberships_subscriptions_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/profile_update(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_profile_update_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"profile_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/unfollow_from_topic(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_unfollow_from_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"unfollow_from_topic"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/update_notification(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_user_update_notification_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"update_notification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_customizable_attributes(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_users_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_users_xl_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_users_xls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/validity/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_validity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"validity"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ventures/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_venture_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ventures(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_ventures_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/whitelabels/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_whitelabel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/whitelabels(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_network_whitelabels_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"whitelabels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_networks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/push_notifications_requirements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_push_notifications_requirements_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"push_notifications_requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/saml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/invitation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_simple_admin_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_simple_admin_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_simple_admin_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_simple_admin_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/admins/administrators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_admins_administrator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/admins/administrators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_admins_administrators_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"administrators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/admins/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_admins_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/admins/recurring_exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_admins_recurring_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"recurring_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/admins/storage/:attachment_id/download(.:format)
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_admins_storage_download_attachment_path = /*#__PURE__*/ __jsr.r({"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[3,"attachment_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/authentications/redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_authentications_redirect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"authentications"],[2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/network_access/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_network_access_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"network_access"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/network_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_network_access_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"network_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/order_management/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_order_management_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/order_management/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_order_management_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/order_management/orders/:order_id/restore_charge_response(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_order_management_order_restore_charge_response_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"restore_charge_response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/order_management/orders/:order_id/retry_purchasable_delivery(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_order_management_order_retry_purchasable_delivery_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"retry_purchasable_delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/order_management/orders/:order_id/retry_receipt(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_order_management_order_retry_receipt_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"retry_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_super_admin_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/unsplash/:unsplash_id/download(.:format)
 * @param {any} unsplash_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_unsplash_download_path = /*#__PURE__*/ __jsr.r({"unsplash_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"unsplash"],[2,[7,"/"],[2,[3,"unsplash_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/unsplash/:unsplash_id/find(.:format)
 * @param {any} unsplash_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_unsplash_find_path = /*#__PURE__*/ __jsr.r({"unsplash_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"unsplash"],[2,[7,"/"],[2,[3,"unsplash_id"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/users_xls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backoffice_users_xls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"users_xls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/badges/:id/users(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const badges_users_backoffice_network_badges_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/billing_informations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_informations_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"billing_informations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/bookmarks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookmarks_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /braintree/to_charge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const braintree_to_charge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"to_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/branding_general(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const branding_general_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"branding_general"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/branding_login(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const branding_login_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"branding_login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/branding_partners(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const branding_partners_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"branding_partners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/roles/:id/bulk_assign(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_assign_backoffice_network_role_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/roles/bulk_assign_status(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_assign_status_backoffice_network_roles_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"bulk_assign_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/community/users/bulk_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_backoffice_api_community_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/bulk_destroy(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_backoffice_network_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/bulk_destroy(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_backoffice_network_topic_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/bulk_destroy(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_backoffice_network_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mentorings/programs/:program_id/emails/bulk_enable(.:format)
 * @param {any} network_id
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_enable_backoffice_network_mentorings_program_emails_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"bulk_enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/bulk_publish(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_publish_backoffice_network_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"bulk_publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/bulk_publish(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_publish_backoffice_network_topic_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"bulk_publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/bulk_send_invitations_emails(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_send_invitations_emails_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_send_invitations_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/bulk_unpublish(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_unpublish_backoffice_network_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"bulk_unpublish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/bulk_unpublish(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_unpublish_backoffice_network_topic_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"bulk_unpublish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/engagement_scoring/scoring_points/bulk_update(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_backoffice_network_engagement_scoring_scoring_points_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"scoring_points"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/admins/notifications/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_private_backoffice_networks_admins_notifications_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/moderations/reported_content_settings/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_private_backoffice_networks_moderations_reported_content_settings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"moderations"],[2,[7,"/"],[2,[6,"reported_content_settings"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/scoring_points/calculations(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calculations_backoffice_network_topic_engagement_scoring_scoring_points_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"scoring_points"],[2,[7,"/"],[2,[6,"calculations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/calendar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events/:id/calendar(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_user_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callback_oauth2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/campaign_informations(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_informations_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"campaign_informations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/bookings/:id/cancel_attendee/:attendee_id(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {any} id
 * @param {any} attendee_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_attendee_user_network_event_booking_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"id":{"r":true},"attendee_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_attendee"],[2,[7,"/"],[2,[3,"attendee_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/orders/:id/cancel(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_backoffice_network_donation_campaign_order_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/cancel(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/cancel(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/cancel_schedule(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_schedule_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"cancel_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/cancel_schedule(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_schedule_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"cancel_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/cancel_schedule(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_schedule_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"cancel_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/cancel_schedule(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_schedule_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"cancel_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_emails/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events/:id/cancel(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/bookings/:id/cancel(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_network_event_booking_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/responses/cancel(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_network_event_responses_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/my_memberships/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_users_my_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"my_memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/updates/:id/canceled(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const canceled_backoffice_network_update_campaigns_update_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"canceled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_backoffice_network_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_backoffice_network_forums_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_backoffice_network_journeys_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center_v2/folders/categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_backoffice_network_media_center_v2_folders_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/categories(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_backoffice_network_topic_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /forums/discussions/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_forums_discussions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /media_center_v2/folders/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_media_center_v2_folders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /portfolios_v2/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_portfolios_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"portfolios_v2"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/news/categories(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_topic_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_topics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/news/categories(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_topics_topic_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /celebrations/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const celebrations_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"celebrations"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/my_memberships/:id/change_credit_card(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_credit_card_users_my_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"my_memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_credit_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/chart_data(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chart_data_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"chart_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /check-ins/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_in_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"check-ins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/memberships_v2/checkout(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_topics_topic_memberships_v2_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships_v2"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/memberships_v2/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_users_memberships_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"memberships_v2"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailing/c/:delivery_token/:link_token(.:format)
 * @param {any} delivery_token
 * @param {any} link_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const click_communications_tracker_path = /*#__PURE__*/ __jsr.r({"delivery_token":{"r":true},"link_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"delivery_token"],[2,[7,"/"],[2,[3,"link_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /colors_and_styles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const colors_and_styles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"colors_and_styles"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/branding/colors(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const colors_backoffice_network_branding_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"colors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_info/colors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const colors_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"colors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /feeds/:access_token/communication_posts(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const communication_posts_feed_path = /*#__PURE__*/ __jsr.r({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"access_token"],[2,[7,"/"],[2,[6,"communication_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/companies(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_backoffice_network_item_urls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/opportunities(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_opportunities_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/people(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_people_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/signup_payments/:uuid/completed(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completed_user_signup_payment_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"signup_payments"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/users/advanced_search/filters/configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configuration_private_backoffice_networks_users_advanced_search_filters_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"advanced_search"],[2,[7,"/"],[2,[6,"filters"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_emails/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_user_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/contact_options(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_options_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"contact_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/contact_options(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_options_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"contact_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/contact_options(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_options_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"contact_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/contact_options(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_options_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"contact_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content_reportings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_reporting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_reportings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_reportings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_reportings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"content_reportings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/convert_to_base(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convert_to_base_backoffice_network_uploads_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"convert_to_base"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/customizable_attributes/:id/copy(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_backoffice_network_bizopp_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_customizable_attributes/copy(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_backoffice_network_donation_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_customizable_attributes"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/customizable_attributes/:id/copy(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_backoffice_network_event_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/customizable_attributes/copy(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_backoffice_network_memberships_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/:membership_id/customizable_attributes/copy(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} membership_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_backoffice_network_topic_membership_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"membership_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"membership_id"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/users/scheduled_feed_posts/count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_private_frontoffice_users_scheduled_feed_posts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"scheduled_feed_posts"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /media_center_v2/files/:uuid/counters(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counters_media_center_v2_files_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"counters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/create_from_xls(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_from_xls_backoffice_network_sub_networks_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[6,"create_from_xls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/emailing_analytics/:id/create_new_user_list(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_new_user_list_backoffice_network_emailing_analytic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"emailing_analytics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_new_user_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/:id/create_payment_cart(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_payment_cart_donation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_payment_cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_settings/create_sendgrid_subuser(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_sendgrid_subuser_backoffice_network_email_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_settings"],[2,[7,"/"],[2,[6,"create_sendgrid_subuser"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/orders/:order_id/matchings/create_user(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_user_backoffice_network_donation_campaign_order_matchings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"matchings"],[2,[7,"/"],[2,[6,"create_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /currencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const currencies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"currencies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/companies/companies/:id/current_employees(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_employees_user_companies_company_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"current_employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_info/current_network(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_network_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"current_network"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/custom_templates(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_templates_backoffice_network_builder_templates_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[6,"custom_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/builder_templates/custom_templates(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_templates_backoffice_network_topic_builder_templates_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[6,"custom_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customizable_attributes/:ca_id(.:format)
 * @param {any} ca_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customizable_attributes_path = /*#__PURE__*/ __jsr.r({"ca_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"ca_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ventures/customizable_attributes(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customizable_attributes_backoffice_network_ventures_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customizable_attributes_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customizable_attributes_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customizable_attributes_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/orders/:order_id/matchings/data(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_backoffice_network_donation_campaign_order_matchings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"matchings"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id/data(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/:venture_id/team_members/:id/decline(.:format)
 * @param {any} topic_id
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_topics_topic_venture_team_member_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:venture_id/team_members/:id/decline(.:format)
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_venture_team_member_path = /*#__PURE__*/ __jsr.r({"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/network_events/:event_id/emails/default_email(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const default_email_backoffice_api_network_events_emails_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"default_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/degrees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const degrees_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"degrees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/delete_document_translations(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_document_translations_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_document_translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/delete_document_translations(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_document_translations_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_document_translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/delete_document_translations(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_document_translations_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_document_translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/delete_file(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_file_backoffice_network_uploads_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"delete_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /uploads/delete_file(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_file_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"delete_file"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id/delete_photo(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_photo_user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/moderation/reported_contents/:id/delete_reported_content(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_reported_content_backoffice_network_moderation_reported_content_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"reported_contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_reported_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/deletion_data(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletion_data_backoffice_network_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"deletion_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/deliveries(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deliveries_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/delivery(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delivery_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/emailing_analytics/:id/delivery/:delivery_token(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {any} delivery_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delivery_backoffice_network_emailing_analytic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"delivery_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"emailing_analytics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delivery"],[2,[7,"/"],[2,[3,"delivery_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/:id/design(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_backoffice_network_builder_template_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/design(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:id/design(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/design(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/design(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id/design(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/design(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/design(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_lists/:id/destroy_auto_rule(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_auto_rule_backoffice_network_user_list_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_auto_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_backoffice_simple_admin_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_backoffice_super_admin_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/destroy_pending_approvals(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_pending_approvals_backoffice_network_approvals_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"destroy_pending_approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/destroy_picture(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_picture_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_picture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sign-out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-out"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/details(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id/details(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/details(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /translations/:id/detect(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detect_translation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"translations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"detect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/my_memberships/:id/digital_membership_card(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const digital_membership_card_users_my_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"my_memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"digital_membership_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/disable(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/disable(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/login_activities/destroy_me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnect_me_private_backoffice_networks_login_activities_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"login_activities"],[2,[7,"/"],[2,[6,"destroy_me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/login_activities/:authenticable_type/:authenticable_id(.:format)
 * @param {any} authenticable_type
 * @param {any} authenticable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnect_target_private_backoffice_networks_login_activities_path = /*#__PURE__*/ __jsr.r({"authenticable_type":{"r":true},"authenticable_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"login_activities"],[2,[7,"/"],[2,[3,"authenticable_type"],[2,[7,"/"],[2,[3,"authenticable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/user_product_notifications/dismiss(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_private_frontoffice_user_product_notifications_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"user_product_notifications"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders/:folder_uuid/files/:uuid/display(.:format)
 * @param {any} user_id
 * @param {any} folder_uuid
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const display_user_portfolio_v2_folder_file_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_uuid":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_uuid"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"display"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/:id/document(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_backoffice_network_builder_template_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/document(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:id/document(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/document(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/document(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id/document(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/document(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/document(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /donations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /donations/braintree/to_charge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_braintree_to_charge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"to_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/feature_flag_all_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_feature_flag_all_flags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"feature_flag_all_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /donations/feature_flag_is_enabled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_feature_flag_is_enabled_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"feature_flag_is_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /donations/feature_flag_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_feature_flag_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"feature_flag_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /donations/feature_flag_test_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_feature_flag_test_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"feature_flag_test_page"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /donations/hep/fetch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_hep_fetch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"hep"],[2,[7,"/"],[2,[6,"fetch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/hep/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_hep_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"hep"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/paypal/client_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_paypal_client_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"client_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/paypal/create_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_paypal_create_order_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"create_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/paypal/to_charge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_paypal_to_charge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"to_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/redis/carts/:cart_uuid(.:format)
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_redis_cart_donations_path = /*#__PURE__*/ __jsr.r({"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"redis"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/sitemap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_sitemap_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"sitemap"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /donations/stripe/config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_stripe_config_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/stripe/setup_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const donations_stripe_setup_intent_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"setup_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/invoices/:id/download(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_backoffice_network_billing_invoice_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/receipts/:id/download(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_backoffice_network_receipt_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"receipts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/:folder_id/files/:id/download(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} folder_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_backoffice_network_topic_media_center_folder_file_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"folder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/users/:user_id/payments/:id/download(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_backoffice_network_topic_user_payment_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/:id/download(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_backoffice_network_upload_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payments/download_csv(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_backoffice_network_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/payments/download_csv(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_backoffice_network_topic_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps/:id/download_mobile_assets(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_mobile_assets_backoffice_network_mobile_app_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_mobile_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/media_center/folders/:folder_id/files/:id/download(.:format)
 * @param {any} topic_id
 * @param {any} folder_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_topics_topic_media_center_folder_file_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"folder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/folders/:folder_id/files/:id/download(.:format)
 * @param {any} user_id
 * @param {any} folder_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_user_portfolio_folder_file_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders/:folder_uuid/files/:uuid/download(.:format)
 * @param {any} user_id
 * @param {any} folder_uuid
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_user_portfolio_v2_folder_file_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_uuid":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_uuid"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/receipts/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_users_receipt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"receipts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/:id/draft_document(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_document_backoffice_network_builder_template_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/draft_document(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_document_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:id/draft_document(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_document_backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/draft_document(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_document_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/draft_document(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_document_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id/draft_document(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_document_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/draft_document(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_document_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/draft_document(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_document_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/user_lists/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_internal_admin_v4_user_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_lists/:id/duplicate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_backoffice_network_user_list_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_private_backoffice_networks_events_network_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/page_customizables/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_private_backoffice_networks_page_customizable_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /articles/new/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_article_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admin_notices/messages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_admin_notices_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admin_notices"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/saml/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_admins_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/app_configuration/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_app_configuration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"app_configuration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/currencies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_currency_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"currencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/account_details/edit(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_account_details_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"account_details"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/activate_users/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_activate_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"activate_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/data_access/roles/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_admins_data_access_role_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"data_access"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/apple/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_apple_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"apple"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/badges/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_badge_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/edit(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_billing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/charges/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_billing_charge_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/invoices/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_billing_invoice_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/subscriptions/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_billing_subscription_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/customizable_attributes/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_bizopp_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_companies_company_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/cookies/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_cookie_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"cookies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/currencies/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_currency_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"currencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management/edit(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_data_management_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donations/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_funds/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_donation_fund_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_funds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_email_analytic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/addons/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_event_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_event_attendee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/booking/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_event_booking_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/donations/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_event_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/tickets/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_event_ticket_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/flash_messages/campaigns/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_flash_messages_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_item_url_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_journey_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_letter_emailing_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/linkedin/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_linkedin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"linkedin"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center/edit(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center/portfolios/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_media_center_portfolio_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"portfolios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/addons/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_memberships_advanced_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/donations/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_memberships_advanced_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_memberships_type_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_mobile_app_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_push_notifications/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_mobile_push_notification_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_push_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/module_store/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_module_store_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"module_store"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_categories/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_network_category_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_emails/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_network_email_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_links/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_network_link_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/pages/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_page_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/sub_page_customizables/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_page_customizable_sub_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"sub_page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/pages_categories_internals/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_pages_categories_internal_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"pages_categories_internals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/partners/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_partner_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payments/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_payment_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_accounts/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_payment_account_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_history_receivers/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_payment_history_receiver_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_history_receivers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/portfolio/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_portfolio_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/promo_codes/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_promo_code_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_recurring_emailing_communication_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/roles/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_role_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/social_plugables/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_social_plugable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"social_plugables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_sso_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso_admin/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_sso_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso_admin"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/storage_tests/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_storage_test_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"storage_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_sub_network_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/:sub_network_id/users/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} sub_network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_sub_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"sub_network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[3,"sub_network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/surveys/forms/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_surveys_form_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ticket_checkins/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_ticket_checkin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ticket_checkins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_event_attendee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_letter_emailing_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_media_center_folder_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/:folder_id/files/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} folder_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_media_center_folder_file_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"folder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_membership_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/addons/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_memberships_advanced_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/donations/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_memberships_advanced_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/payments/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_payment_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_recurring_emailing_communication_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/users/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/ventures/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topic_venture_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics_categories/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topics_category_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/category_sets/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_topics_category_set_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/universal_tags/tags/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_universal_tags_tag_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"universal_tags"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_upload_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_events/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_user_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_lists/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_user_list_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_user_memberships_subscription_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_users_xl_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ventures/:id/edit(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_network_venture_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/push_notifications_requirements/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_push_notifications_requirements_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"push_notifications_requirements"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/saml/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_simple_admin_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/admins/administrators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_super_admin_admins_administrator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/network_access/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_backoffice_super_admin_network_access_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"network_access"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cas/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_cas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cas"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /forums/discussions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_forums_discussion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jwt_auth/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_jwt_auth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jwt_auth"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/:id/edit_mail(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mail_backoffice_network_approval_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/approvals/:id/edit_mail(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mail_backoffice_network_topic_approval_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recruiter/jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_networks_recruiter_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"recruiter"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth2/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_oauth2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /opportunities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_opportunity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/addons/:id/edit(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_private_backoffice_networks_events_network_event_addon_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/donations/:id/edit(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_private_backoffice_networks_events_network_event_donation_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/tickets/:id/edit(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_private_backoffice_networks_events_network_event_ticket_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /saml/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/ventures/:id/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_topic_venture_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/business_opportunities/requests/:id/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_topics_topic_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/followings/:id/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_topics_topic_following_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"followings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/:id/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_topics_topic_venture_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/:venture_id/team_members/:id/edit(.:format)
 * @param {any} topic_id
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_topics_topic_venture_team_member_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/articles/:uuid/edit(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_article_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/requests/:id/edit(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit-header(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_header_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit-header"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/signup_payments/:uuid/edit(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_signup_payment_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"signup_payments"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id/edit(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_profiles/edit(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_user_profiles_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_profiles"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ventures/ventures/:id/edit(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_ventures_venture_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_venture_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/education_customizable_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const education_customizable_attributes_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"education_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/email_list(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_list_backoffice_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"email_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/email_list(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_list_backoffice_network_topic_event_attendees_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"email_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:id/email_list(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_list_private_backoffice_networks_events_network_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_domains/enable(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_backoffice_network_email_domains_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_domains"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/enable(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/enable(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /playwright/networks/:network_id/users/:id/enable_with_default_password(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_with_default_password_playwright_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"playwright"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_with_default_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/:id(.:format)
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_attendee_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/event_guest(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_guest_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"event_guest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/event_guests(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_guests_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"event_guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/p/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_preview_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/flash_messages/notifications/:id/event(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_user_flash_messages_notification_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/events(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_backoffice_network_item_urls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/event/:event_id/attendees(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"event"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/event/:event_id/ticket_ranges(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_event_ticket_ranges_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"event"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/events_export(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_export_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"events_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /feeds/:access_token/events(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_feed_path = /*#__PURE__*/ __jsr.r({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"access_token"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /feeds/:access_token/events/calendar(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_feed_calendar_path = /*#__PURE__*/ __jsr.r({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"access_token"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/experience_customizable_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const experience_customizable_attributes_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"experience_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/emailing_analytics/:id/export(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_backoffice_network_emailing_analytic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"emailing_analytics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payments/export(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_backoffice_network_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/surveys/forms/:id/export(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_backoffice_network_surveys_form_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/payments/export(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_backoffice_network_topic_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/export(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_backoffice_network_users_xls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/external_integrations/exporter(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exporter_backoffice_network_external_integrations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"external_integrations"],[2,[7,"/"],[2,[6,"exporter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_activities/exports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exports_backoffice_network_user_activities_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_activities"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_connect_root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/external_integrations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_integrations_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"external_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/external_integrations/external_logs(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_logs_backoffice_network_external_integrations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"external_integrations"],[2,[7,"/"],[2,[6,"external_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/orders/fail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fail_order_management_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"fail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /favicon.ico(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favicon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"favicon"],[2,[8,"."],[2,[6,"ico"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fb-channel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fb_channel_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"fb-channel"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feature_flag_all_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_flag_all_flags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flag_all_flags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feature_flag_is_enabled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_flag_is_enabled_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flag_is_enabled"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feature_flag_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_flag_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flag_settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feature_flag_test_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_flag_test_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flag_test_page"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /features_activated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const features_activated_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"features_activated"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/settings/features(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const features_backoffice_network_topic_settings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_info/features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const features_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feed_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feed_items"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feed_posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_post_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feed_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/feed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_discussions(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_discussions_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_events(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_events_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_news(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_news_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_opportunities(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_opportunities_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_posts(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_posts_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_projects(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_projects_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_topics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_topics_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_trips_and_checkins(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_trips_and_checkins_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_trips_and_checkins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/fetch_users(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_users_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"fetch_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_activities/filter(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_backoffice_network_user_activities_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_activities"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/filters_permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filters_permissions_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"filters_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/find_uploads(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_uploads_backoffice_network_uploads_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"find_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/:id/folder_cover_picture(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const folder_cover_picture_backoffice_network_topic_media_center_folder_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"folder_cover_picture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center/folder/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const folder_uuid_backoffice_network_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folder"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folder/:id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const folder_uuid_backoffice_network_topic_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folder"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id/followed_topics(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const followed_topics_user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"followed_topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/branding/fonts(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fonts_backoffice_network_branding_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"fonts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/configs_attributes/fonts(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fonts_backoffice_network_configs_attributes_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"configs_attributes"],[2,[7,"/"],[2,[6,"fonts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/external_integrations/force_sync(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const force_sync_backoffice_network_external_integrations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"external_integrations"],[2,[7,"/"],[2,[6,"force_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/form_preview(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const form_preview_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"form_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /forum(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forum_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forum"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /forum/t/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forum_edit_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /forum/t/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forum_new_thread_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /forum/t/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forum_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/forum(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forum_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"forum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/forums(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forums_backoffice_network_item_urls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[6,"forums"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /forums/discussions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forums_discussion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /forums/discussions/:discussion_id/summary(.:format)
 * @param {any} discussion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forums_discussion_summary_path = /*#__PURE__*/ __jsr.r({"discussion_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[3,"discussion_id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /forums/discussions/:discussion_id/toggle_follow(.:format)
 * @param {any} discussion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forums_discussion_toggle_follow_path = /*#__PURE__*/ __jsr.r({"discussion_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[3,"discussion_id"],[2,[7,"/"],[2,[6,"toggle_follow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /forums/discussions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forums_discussions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /frontoffice/api/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frontoffice_api_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/funds(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const funds_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"funds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/:id/funds(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const funds_donation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"funds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/:id/general(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const general_backoffice_network_builder_template_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"general"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso_admin/generate_certificate(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_certificate_backoffice_network_sso_admin_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso_admin"],[2,[7,"/"],[2,[6,"generate_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso/generate_certificate(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_certificate_backoffice_network_sso_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"generate_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/users/advanced_search/ai/filters/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_private_backoffice_networks_users_advanced_search_ai_filters_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"advanced_search"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"filters"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/global_report(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const global_report_backoffice_network_donation_campaigns_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[6,"global_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/google_cloud_translate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_cloud_translate_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"google_cloud_translate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/google_tag_manager(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_tag_manager_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"google_tag_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_profiles/header_data(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const header_data_user_user_profiles_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_profiles"],[2,[7,"/"],[2,[6,"header_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hide_user_publications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hide_user_publication_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"hide_user_publications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hide_user_publications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hide_user_publications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hide_user_publications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /events/:id/highlighted_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const highlighted_events_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"highlighted_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/history(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/history(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/app_status(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_app_status_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"app_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/general_info(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_general_info_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"general_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/branding_assets(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_branding_assets_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"branding_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/branding_assets/:id(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_branding_asset_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"branding_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/branding_assets_zip(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_branding_assets_zip_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"branding_assets_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/global_state(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_global_state_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"global_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/preparation(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_preparation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"preparation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/itunes_account(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_itunes_account_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"itunes_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //backoffice/networks/:network_id/mobile_apps/google_play_account(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_google_play_account_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"google_play_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //app_factory_api/network_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_network_ids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"app_factory_api"],[2,[7,"/"],[2,[6,"network_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * //app_factory_api/app_versions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_app_versions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"app_factory_api"],[2,[7,"/"],[2,[6,"app_versions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * //app_factory_api/oauth_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_oauth_app_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"app_factory_api"],[2,[7,"/"],[2,[6,"oauth_app"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * //app_factory_api/networks/:network_id/app_status/reset(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_app_status_reset_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"app_factory_api"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"app_status"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * //app_factory_api/networks/:network_id/configs(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_configs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"app_factory_api"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * //app_factory_api/networks/:network_id/ios_google_services_plists(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_ios_google_services_plists_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"app_factory_api"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ios_google_services_plists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * //app_factory_api/networks/:network_id/android_google_services(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_mobile_apps_bo_android_google_services_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"app_factory_api"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"android_google_services"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/hivebrite_templates(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_templates_backoffice_network_builder_templates_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[6,"hivebrite_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/builder_templates/hivebrite_templates(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hivebrite_templates_backoffice_network_topic_builder_templates_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[6,"hivebrite_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/home(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage/homepage_harry(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const homepage_harry_backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[2,[7,"/"],[2,[6,"homepage_harry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /html_document(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const html_document_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"html_document"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/import(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_backoffice_network_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/:id/import(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_backoffice_network_users_xl_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/:id/import_logs(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_logs_backoffice_network_users_xl_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/:id/import_status(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_status_backoffice_network_users_xl_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/industries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const industries_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"industries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/carts_v2/init(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const init_order_management_carts_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[6,"init"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/carts_v2/init(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const init_topic_order_management_carts_v2_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[6,"init"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/invitation_email(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitation_email_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invitation_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:id/invitation_email(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitation_email_backoffice_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invitation_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/invitation_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitation_settings_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invitation_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:id/invite(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite_backoffice_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /feeds/:access_token/jobs(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jobs_feed_path = /*#__PURE__*/ __jsr.r({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"access_token"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /journeys/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journey_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /journeys/:journey_id/details(.:format)
 * @param {any} journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journey_details_path = /*#__PURE__*/ __jsr.r({"journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"journey_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /journeys/:journey_id/progress(.:format)
 * @param {any} journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journey_progress_path = /*#__PURE__*/ __jsr.r({"journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"journey_id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /journeys/:journey_id/step(.:format)
 * @param {any} journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journey_step_path = /*#__PURE__*/ __jsr.r({"journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"journey_id"],[2,[7,"/"],[2,[6,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /journeys/:journey_id/users(.:format)
 * @param {any} journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journey_users_path = /*#__PURE__*/ __jsr.r({"journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"journey_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /journeys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journeys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /journeys/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journeys_details_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /journeys/:id/:step(.:format)
 * @param {any} id
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journeys_step_id_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /journeys/:id/success(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journeys_success_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/:id/users(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const journeys_users_backoffice_network_journeys_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/just_emails(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const just_emails_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"just_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/just_emails(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const just_emails_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"just_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/just_emails(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const just_emails_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"just_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/just_emails(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const just_emails_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"just_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jwt_auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jwt_auth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jwt_auth"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /landing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/landing_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_page_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"landing_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/language(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const language_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"language"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/linkedin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkedin_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"linkedin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/locales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locales_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"locales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/zendesk/sso/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_backoffice_zendesk_sso_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"zendesk"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_info/login_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_settings_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"login_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:id/logo(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logo_backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/:id/logo(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logo_backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/branding/logos(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logos_backoffice_network_branding_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"logos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/saml/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_backoffice_admins_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/saml/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_backoffice_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/zendesk/sso/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_backoffice_zendesk_sso_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"zendesk"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cas/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_cas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cas"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jwt_auth/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_jwt_auth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jwt_auth"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth2/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_oauth2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /saml/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/saml/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_saml_backoffice_admins_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/saml/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_saml_backoffice_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /saml/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_saml_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /token_update_campaigns/updates/:id/mail_opened(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mail_opened_token_update_campaigns_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"token_update_campaigns"],[2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mail_opened"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/mail_preview(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mail_preview_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mail_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailchimp/admin_subscriptions/:webhook_token(.:format)
 * @param {any} webhook_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailchimp_path = /*#__PURE__*/ __jsr.r({"webhook_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailchimp"],[2,[7,"/"],[2,[6,"admin_subscriptions"],[2,[7,"/"],[2,[3,"webhook_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/main_page_to_sub_page(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const main_page_to_sub_page_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"main_page_to_sub_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/main_page_to_sub_page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const main_page_to_sub_page_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"main_page_to_sub_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/main_page_to_sub_page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const main_page_to_sub_page_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"main_page_to_sub_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/make_private(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_private_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"make_private"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/make_private(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_private_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"make_private"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/make_public(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_public_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"make_public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/make_public(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_public_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"make_public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/moderation/reported_contents/:id/make_reported_content_unvisible(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_reported_content_unvisible_backoffice_network_moderation_reported_content_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"reported_contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"make_reported_content_unvisible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/moderation/reported_contents/:id/make_reported_content_visible(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_reported_content_visible_backoffice_network_moderation_reported_content_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"reported_contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"make_reported_content_visible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/markers_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makers_v2_events_json_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"markers_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/manage(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_backoffice_network_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/:id/manage_user_matching_request(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_user_matching_request_backoffice_network_approval_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_user_matching_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/approvals/:id/manage_user_matching_request(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_user_matching_request_backoffice_network_topic_approval_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_user_matching_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manifest_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/map(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const map_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/events/markers(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markers_topics_topic_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"markers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events/markers(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markers_user_events_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"markers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/markers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markers_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"markers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/markers_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markers_v2_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"markers_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events_markers_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markers_v2_po_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events_markers_v2"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/events/markers_v2(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markers_v2_topics_topic_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"markers_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/markers_v2(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markers_v2_user_network_events_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"markers_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/markers_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markers_v2_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"markers_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events/:id/maybe_attend(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maybe_attend_user_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"maybe_attend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/responses/maybe_attend(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maybe_attend_user_network_event_responses_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[6,"maybe_attend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /me/my-events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /me/my-events/:eventId/orders(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_events_orders_path = /*#__PURE__*/ __jsr.r({"eventId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-events"],[2,[7,"/"],[2,[3,"eventId"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /me/my-memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_memberships_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /me/my-memberships/digital-membership-card/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_memberships_digital_membership_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-memberships"],[2,[7,"/"],[2,[6,"digital-membership-card"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /me/my-portfolio(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_portfolio_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-portfolio"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /me/my-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /me/my-settings/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_settings_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-settings"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /me/my-settings/languages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_settings_languages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-settings"],[2,[7,"/"],[2,[6,"languages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /me/my-settings/notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_settings_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-settings"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /me/my-settings/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_settings_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /me/my-settings/privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_my_settings_privacy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"my-settings"],[2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /me/notification_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_notification_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /media_center(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_center_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media_center"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /media_center/file/:uuid(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_center_file_view_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /media_center/folder/:uuid(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_center_folder_view_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folder"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/media_center(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_center_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"media_center"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /media_center_v2/files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_center_v2_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /media_center_v2/folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_center_v2_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /media_center_v2/folders/:folder_id/files(.:format)
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_center_v2_folder_files_path = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /media_center_v2/folders/:folder_id/folders(.:format)
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_center_v2_folder_folders_path = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_center_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /memberships/:id/success(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membership_success_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/order(/:id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_order_path = /*#__PURE__*/ __jsr.r({"id":{},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/order(/:id)/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_order_billing_path = /*#__PURE__*/ __jsr.r({"id":{},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/order(/:id)/completed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_order_completed_path = /*#__PURE__*/ __jsr.r({"id":{},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/order/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_order_create_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/order(/:id)/payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_order_payment_path = /*#__PURE__*/ __jsr.r({"id":{},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/order(/:id)/registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_order_registration_path = /*#__PURE__*/ __jsr.r({"id":{},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"memberships_v2"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/mentoring_programs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentoring_programs_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"mentoring_programs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/mentee_customizable_attributes(.:format)
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_mentee_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentee_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/mentee_profiles/:id(.:format)
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_mentee_profile_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentee_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/mentee_profiles(.:format)
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_mentee_profiles_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentee_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/mentor_customizable_attributes(.:format)
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_mentor_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentor_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/mentor_profiles/:id(.:format)
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_mentor_profile_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentor_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/mentor_profiles(.:format)
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_mentor_profiles_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"mentor_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/relationships/:id(.:format)
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_relationship_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/relationships(.:format)
 * @param {any} program_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_relationships_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"relationships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/user_mentee_profiles/:id(.:format)
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_user_mentee_profile_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"user_mentee_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs/:program_id/user_mentor_profiles/:id(.:format)
 * @param {any} program_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_program_user_mentor_profile_path = /*#__PURE__*/ __jsr.r({"program_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"program_id"],[2,[7,"/"],[2,[6,"user_mentor_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentorings/programs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentorings_programs_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mentorings"],[2,[7,"/"],[2,[6,"programs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/module_store/menu(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const menu_backoffice_network_module_store_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"module_store"],[2,[7,"/"],[2,[6,"menu"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/menu(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const menu_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"menu"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messaging(/*path)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messaging_path = /*#__PURE__*/ __jsr.r({"path":{},"format":{}}, [2,[7,"/"],[2,[6,"messaging"],[2,[1,[2,[7,"/"],[5,[3,"path"]]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/messaging(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messaging_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"messaging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /messaging/channels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messaging_channel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messaging"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messaging/conversations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messaging_new_conversation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messaging"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messaging/conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messaging_show_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messaging"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/saml/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metadata_backoffice_admins_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/saml/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metadata_backoffice_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /saml/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metadata_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage/most_popular_events(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const most_popular_events_backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[2,[7,"/"],[2,[6,"most_popular_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage/most_popular_user_contents(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const most_popular_user_contents_backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[2,[7,"/"],[2,[6,"most_popular_user_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage/most_popular_users(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const most_popular_users_backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[2,[7,"/"],[2,[6,"most_popular_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /me/show(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_profile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/login_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_status_private_backoffice_networks_login_activities_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"login_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/page_customizables/names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const names_private_frontoffice_page_customizables_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[6,"names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/nationalities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nationalities_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"nationalities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const native_oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/admins/administrators/:id/network_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_access_backoffice_super_admin_admins_administrator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"network_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /network_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"network_categories"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/navigation/landing_page/network_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_config_backoffice_api_navigation_landing_page_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"navigation"],[2,[7,"/"],[2,[6,"landing_page"],[2,[7,"/"],[2,[6,"network_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_info/network_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_configuration_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"network_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/:id(.:format)
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_attendee_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/calendar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_calendar_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/highlighted_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_highlighted_events_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"highlighted_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/page/:page_id(.:format)
 * @param {any} id
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"page_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/payment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_payment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/registration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_registration_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/related_topics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_related_topics_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/success(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_event_success_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking/:cartId/billing(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_billing_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking/:cartId/billing/donations(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_billing_donations_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking/:cartId(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_id_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking/:cartId/payment(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_payment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking/:cartId/registration(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_registration_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking/:cartId/registration/donations(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_registration_donations_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking/:cartId/success(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_success_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/booking/:cartId/ticket-selection(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_booking_ticket_selection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"ticket-selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/online(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_online_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"online"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/online-completed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_online_completed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"online-completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/page/:page_id(.:format)
 * @param {any} id
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"page_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/payment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_payment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/registration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_registration_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id/success(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_events_event_success_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /news/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_letter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /news(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_letters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /locales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_locales_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"locales"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /news/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_news_categories_json_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /page/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_page_customizable_json_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /page/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_page_customizables_custom_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /privacy_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_privacy_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_public_root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_signup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sso_user_not_found(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_sso_user_not_found_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso_user_not_found"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user_markers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_user_markers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_markers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /waiting_for_new_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_waiting_for_new_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"waiting_for_new_password"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /networks/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const networks_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /recruiter/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const networks_recruiter_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"recruiter"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /recruiter/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const networks_recruiter_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recruiter"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /news/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admin_notices/messages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_admin_notices_message_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admin_notices"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/saml/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_admins_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/app_configuration/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_app_configuration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"app_configuration"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/currencies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_currency_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"currencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/activate_users/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_activate_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"activate_users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admin_notification_emails/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_admin_notification_email_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admin_notification_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/data_access/roles/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_admins_data_access_role_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"data_access"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/imports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_admins_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/apple/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_apple_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"apple"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/exports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_approvals_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/badges/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_badge_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_billing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/charges/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_billing_charge_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/invoices/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_billing_invoice_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/subscriptions/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_billing_subscription_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_companies_company_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/:company_id/experiences/new(.:format)
 * @param {any} network_id
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_companies_company_experience_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"experiences"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/experiences/imports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_companies_experiences_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"experiences"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/imports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_companies_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/cookies/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_cookie_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"cookies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/currencies/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_currency_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"currencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_data_management_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management/exports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_data_management_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donations/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/exports/new(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_donation_campaign_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/orders/new(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_donation_campaign_order_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/orders/:order_id/matchings/new(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_donation_campaign_order_matching_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"matchings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_funds/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_donation_fund_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_funds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_email_analytic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_domains/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_email_domain_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/engagement_scoring/exports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_engagement_scoring_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/addons/new(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/new(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_attendee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/imports/new(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_attendees_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/donations/new(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/attendees/exports/new(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/new(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/responses_exports/new(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_responses_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/tickets/new(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_event_ticket_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/feed_sources/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_feed_source_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"feed_sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/flash_messages/campaigns/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_flash_messages_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/flash_messages/campaigns/:campaign_id/recipients/new(.:format)
 * @param {any} network_id
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_flash_messages_campaign_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/imports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_forums_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_item_url_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_journey_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/new(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_letter_emailing_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/linkedin/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_linkedin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"linkedin"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center/portfolios/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_media_center_portfolio_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"portfolios"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/addons/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_memberships_advanced_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/donations/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_memberships_advanced_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/exports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_memberships_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/orders/exports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_memberships_orders_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/subscriptions/imports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_memberships_subscriptions_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_memberships_type_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/imports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_memberships_types_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_mobile_app_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_push_notifications/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_mobile_push_notification_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_push_notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/module_store/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_module_store_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"module_store"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_categories/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_network_category_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_links/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_network_link_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/exports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_opportunities_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/pages/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_page_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:page_customizable_id/sub_page_customizables/new(.:format)
 * @param {any} network_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_page_customizable_sub_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"sub_page_customizables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/pages_categories_internals/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_pages_categories_internal_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"pages_categories_internals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/partners/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_partner_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payments/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_payment_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_accounts/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_payment_account_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payment_history_receivers/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_payment_history_receiver_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payment_history_receivers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/portfolio/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_portfolio_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/promo_codes/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_promo_code_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/new(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_recurring_emailing_communication_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/roles/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_role_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_sso_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso_admin/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_sso_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso_admin"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/storage_tests/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_storage_test_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"storage_tests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_sub_network_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/:sub_network_id/users/new(.:format)
 * @param {any} network_id
 * @param {any} sub_network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_sub_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"sub_network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[3,"sub_network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/surveys/forms/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_surveys_form_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ticket_checkins/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_ticket_checkin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ticket_checkins"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/exports/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_engagement_scoring_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_event_attendee_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/attendees/exports/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_event_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/responses_exports/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_event_responses_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses_exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_letter_emailing_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_media_center_folder_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/folders/:folder_id/files/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_media_center_folder_file_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/exports/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_members_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_membership_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/addons/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_memberships_advanced_addon_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/donations/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_memberships_advanced_donation_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/exports/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_memberships_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/orders/exports/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_memberships_orders_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:page_customizable_id/sub_page_customizables/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} page_customizable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_page_customizable_sub_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"page_customizable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"page_customizable_id"],[2,[7,"/"],[2,[6,"sub_page_customizables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/payments/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_payment_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_recurring_emailing_communication_recipient_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/users/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/ventures/new(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topic_venture_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics_categories/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topics_category_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/category_sets/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topics_category_set_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/exports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topics_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/imports/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_topics_import_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/universal_tags/tags/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_universal_tags_tag_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"universal_tags"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/uploads/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_upload_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/user_lists/:user_list_id/exports/new(.:format)
 * @param {any} network_id
 * @param {any} user_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_user_list_export_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"user_list_id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:user_id/memberships/subscriptions/new(.:format)
 * @param {any} network_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_user_memberships_subscription_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_users_xl_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ventures/new(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_network_venture_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/push_notifications_requirements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_push_notifications_requirements_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"push_notifications_requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/saml/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/invitation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_simple_admin_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_simple_admin_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_simple_admin_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_simple_admin_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admin/network_access/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_super_admin_network_access_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admin"],[2,[7,"/"],[2,[6,"network_access"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_backoffice_super_admin_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cas/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_cas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /forums/discussions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_forums_discussion_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/new_from_xls(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_from_xls_backoffice_network_sub_networks_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[6,"new_from_xls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage/new_jobs_posted(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_jobs_posted_backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[2,[7,"/"],[2,[6,"new_jobs_posted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_joiners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_joiner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_joiners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_joiner_post/:user_id(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_joiner_post_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_joiner_post"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /news/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_json_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jwt_auth/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_jwt_auth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jwt_auth"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/new(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_network_event_attendee_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recruiter/jobs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_networks_recruiter_job_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recruiter"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth2/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /opportunities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_opportunity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/data_management/exports/new_post(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_post_backoffice_network_data_management_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"data_management"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/educations/exports/new_post(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_post_backoffice_network_educations_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"educations"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/exports/new_post(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_post_backoffice_network_topic_members_exports_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/exports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_private_backoffice_networks_events_export_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/addons/new(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_private_backoffice_networks_events_network_event_addon_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/donations/new(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_private_backoffice_networks_events_network_event_donation_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/event_responses/exports/new(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_private_backoffice_networks_events_network_event_event_responses_export_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"event_responses"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/exports/new(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_private_backoffice_networks_events_network_event_export_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/tickets/new(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_private_backoffice_networks_events_network_event_ticket_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /saml/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/new_send_test(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_send_test_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_send_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/new/steps(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_steps_backoffice_network_journeys_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/new/steps/create(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_steps_create_backoffice_network_journeys_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"steps"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/new/success-page(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_success_page_backoffice_network_journeys_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"success-page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/new_test_mail(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_test_mail_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new_test_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/new_test_mail(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_test_mail_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new_test_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/new_test_mail(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_test_mail_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new_test_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/new_test_mail(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_test_mail_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new_test_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/ventures/new(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_topic_venture_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/approvals/new(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_topics_topic_approval_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/business_opportunities/requests/new(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_topics_topic_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/followings/new(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_topics_topic_following_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"followings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/posts/new(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_topics_topic_post_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/new(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_topics_topic_venture_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/:venture_id/team_members/new(.:format)
 * @param {any} topic_id
 * @param {any} venture_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_topics_topic_venture_team_member_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"venture_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/articles/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_article_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_authentication_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/requests/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/new_confirm(/:invite_token)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirm_path = /*#__PURE__*/ __jsr.r({"invite_token":{},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_confirm"],[2,[1,[2,[7,"/"],[3,"invite_token"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user-invitation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user-invitation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/locations/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_location_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/posts/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_post_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sign-in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/signup_payments/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_signup_payment_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"signup_payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/trips/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_trip_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe(/:notification_token)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unsubscribe_path = /*#__PURE__*/ __jsr.r({"notification_token":{},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe"],[2,[1,[2,[7,"/"],[3,"notification_token"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe_v2(/:notification_token)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unsubscribe_v2_path = /*#__PURE__*/ __jsr.r({"notification_token":{},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_v2"],[2,[1,[2,[7,"/"],[3,"notification_token"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_profiles/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_user_profiles_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ventures/ventures/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_ventures_venture_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_venture_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /news(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const news_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/news(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const news_backoffice_network_item_urls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /news/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const news_categories_json_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /feeds/:access_token/news(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const news_feed_path = /*#__PURE__*/ __jsr.r({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"access_token"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /news(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const news_json_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /topics/:id/news(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const news_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/module_store/:id/notification(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_backoffice_network_module_store_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"module_store"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /me/notification_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_settings_me_notification_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /me/notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /me/notifications/:id/redirect(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_redirect_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sub_networks/:sub_network_id/users/:id/notify(.:format)
 * @param {any} network_id
 * @param {any} sub_network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notify_backoffice_network_sub_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"sub_network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sub_networks"],[2,[7,"/"],[2,[3,"sub_network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:id/notify(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notify_backoffice_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/notify_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notify_users_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notify_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/:id/notifyable_info(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifyable_info_user_notification_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notifyable_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth2"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /auth/client_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth2_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"client_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorized_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorized_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorized_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorized_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_introspect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe_v2/one_click_unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const one_click_unsubscribe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_v2"],[2,[7,"/"],[2,[6,"one_click_unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /opportunities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opportunities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/opportunities(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opportunities_backoffice_network_item_urls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /opportunities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opportunity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/customizable_attributes/options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const options_private_backoffice_networks_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/carts_v2/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_management_carts_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/carts_v2/:carts_v2_id/cart_items/:id(.:format)
 * @param {any} carts_v2_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_management_carts_v2_cart_item_path = /*#__PURE__*/ __jsr.r({"carts_v2_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"carts_v2_id"],[2,[7,"/"],[2,[6,"cart_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/carts_v2/:carts_v2_id/cart_items(.:format)
 * @param {any} carts_v2_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_management_carts_v2_cart_items_path = /*#__PURE__*/ __jsr.r({"carts_v2_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"carts_v2_id"],[2,[7,"/"],[2,[6,"cart_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/carts_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_management_carts_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /order_management/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_management_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_management_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/overview(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overview_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/overview(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overview_backoffice_network_letter_emailings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /page/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_customizables_custom_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session_info/page_customizables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_customizables_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/navigation/landing_page/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_backoffice_api_navigation_landing_page_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"navigation"],[2,[7,"/"],[2,[6,"landing_page"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id/password(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/companies/companies/:id/past_employees(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const past_employees_user_companies_company_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"past_employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/pay_later(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pay_later_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"pay_later"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/pay_later(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pay_later_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"pay_later"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payment_page/:cart_uuid(.:format)
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_page_path = /*#__PURE__*/ __jsr.r({"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payment_page"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/signup_payments/:uuid/payment(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_user_signup_payment_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"signup_payments"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /paypal/client_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_client_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"client_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /paypal/create_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_create_order_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"create_order"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /paypal/to_charge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_to_charge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"to_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage/pending_mentoring_applications_count(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_mentoring_applications_count_backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[2,[7,"/"],[2,[6,"pending_mentoring_applications_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content_reportings/pending_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_report_content_reportings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"content_reportings"],[2,[7,"/"],[2,[6,"pending_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage/pending_requests_to_join_count(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_requests_to_join_count_backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[2,[7,"/"],[2,[6,"pending_requests_to_join_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/user_product_notifications/pendings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pendings_private_frontoffice_user_product_notifications_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"user_product_notifications"],[2,[7,"/"],[2,[6,"pendings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /people/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/:id/permissions(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissions_backoffice_network_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/permissions(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissions_backoffice_network_admins_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/:id/permissions(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissions_backoffice_network_topic_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/permissions(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissions_backoffice_network_topic_admins_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pick-institution(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pick_institution_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pick-institution"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/unsplash/pictures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pictures_backoffice_unsplash_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"unsplash"],[2,[7,"/"],[2,[6,"pictures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/redis/carts/:cart_uuid(.:format)
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_donations_redis_cart_donations_path = /*#__PURE__*/ __jsr.r({"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"redis"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking/:cartId/billing(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_billing_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking/:cartId/billing/donations(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_billing_donations_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking/:cartId(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_id_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking/:cartId/payment(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_payment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking/:cartId/registration(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_registration_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking/:cartId/registration/donations(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_registration_donations_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking/:cartId/success(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_success_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/booking/:cartId/ticket-selection(.:format)
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_network_events_event_booking_ticket_selection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"ticket-selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payment_page/:cart_uuid(.:format)
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_payment_page_path = /*#__PURE__*/ __jsr.r({"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payment_page"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /redis/carts/:cart_uuid(.:format)
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const po_redis_cart_path = /*#__PURE__*/ __jsr.r({"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"redis"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/portfolio_preview(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portfolio_preview_user_users_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"portfolio_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /portfolios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portfolios_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"portfolios"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /portfolios/file/:uuid(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portfolios_file_view_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"portfolios"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /portfolios_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portfolios_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"portfolios_v2"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /post_upload_publish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_upload_publish_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"post_upload_publish"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"presign"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/preview(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_billing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_builder_template_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/receipts/preview(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_receipts_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"receipts"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/preview(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_donation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:id/preview_draft(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_draft_backoffice_network_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/preview_draft(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_draft_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:id/preview_draft(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_draft_backoffice_network_topic_letter_emailing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/preview_draft(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_draft_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/preview_public_homepage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_public_homepage_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_public_homepage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id/preview(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/account_details/privacy(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_backoffice_network_account_details_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"account_details"],[2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_admins_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/admins/notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_admins_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/admins/notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_admins_notifications_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/ai/feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_ai_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/ai/form_suggestions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_ai_form_suggestions_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"form_suggestions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/customizable_attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_customizable_attribute_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"customizable_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/customizable_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_customizable_attributes_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/exports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_exports_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/addons/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_addon_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/addons(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_addons_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"addons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/attendees/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_attendee_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/attendees(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/bookings/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_booking_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/bookings(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_bookings_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/donations/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_donation_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/donations(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_donations_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/event_responses/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_event_response_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"event_responses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/event_responses(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_event_responses_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"event_responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/event_responses/exports/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_event_responses_export_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"event_responses"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/event_responses/exports(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_event_responses_exports_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"event_responses"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/exports/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_export_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/exports(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_exports_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/tickets/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_ticket_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/ticket_checkins/:id(.:format)
 * @param {any} network_event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_ticket_checkin_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"ticket_checkins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/ticket_checkins(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_ticket_checkins_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"ticket_checkins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events/:network_event_id/tickets(.:format)
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_event_tickets_path = /*#__PURE__*/ __jsr.r({"network_event_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/network_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_network_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"network_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_reports_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/events/user_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_events_user_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/:network_id/login_activities/config(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_login_activities_config_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"login_activities"],[2,[7,"/"],[2,[6,"config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/moderations/reported_content_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_moderations_reported_content_settings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"moderations"],[2,[7,"/"],[2,[6,"reported_content_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/news/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_news_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/news/bulks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_news_bulks_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"bulks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/news/:news_id/duplicates(.:format)
 * @param {any} news_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_news_duplicates_path = /*#__PURE__*/ __jsr.r({"news_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"news_id"],[2,[7,"/"],[2,[6,"duplicates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/news(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_news_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/page_customizables/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_page_customizable_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/page_customizables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_page_customizables_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/user_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_user_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/user_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_networks_user_lists_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/topics/:topic_id/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_topic_news_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/topics/:topic_id/news/bulks(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_topic_news_bulks_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"bulks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/topics/:topic_id/news/:news_id/duplicates(.:format)
 * @param {any} topic_id
 * @param {any} news_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_topic_news_duplicates_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"news_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"news_id"],[2,[7,"/"],[2,[6,"duplicates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/topics/:topic_id/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_topic_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/topics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_backoffice_topics_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/ai/form_suggestions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_ai_form_suggestions_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"form_suggestions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/ai/recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_ai_recommendations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"recommendations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/ai/searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_ai_searches_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"searches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/ai/text_enhancements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_ai_text_enhancements_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"text_enhancements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/ai/tracking_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_ai_tracking_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"tracking_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/ai/user_recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_ai_user_recommendations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"user_recommendations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/discussions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_discussions_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/news/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_news_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/news(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_news_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_posts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/discussions(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_discussions_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/events/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_event_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/events(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_news_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/posts(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_posts_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/topics/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_topic_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/topics(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_topics_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics/:topic_id/users(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topic_users_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/topics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_topics_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/dynamic_components/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_dynamic_components_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/login_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_login_activities_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"login_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/news/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_news_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/news(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_news_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/polls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_poll_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/polls/:poll_id/votes(.:format)
 * @param {any} poll_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_poll_votes_path = /*#__PURE__*/ __jsr.r({"poll_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"poll_id"],[2,[7,"/"],[2,[6,"votes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/polls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_polls_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"polls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/settings/header_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_settings_header_menu_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"header_menu"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/topics/:topic_id/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_topics_news_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/topics/:topic_id/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_topics_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/users/notify_people/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_users_notify_people_fields_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"notify_people"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/users/notify_people/recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_users_notify_people_recommendations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"notify_people"],[2,[7,"/"],[2,[6,"recommendations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/users/profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_users_profile_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/users/scheduled_feed_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_users_scheduled_feed_posts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"scheduled_feed_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/frontoffice/topics/:topic_id/users/notify_people/recommendations(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_frontoffice_users_topics_notify_people_recommendations_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"frontoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"notify_people"],[2,[7,"/"],[2,[6,"recommendations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/news/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_news_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/news(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_news_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/topics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/topics/:topic_id/events/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_topic_event_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/topics/:topic_id/events(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_topic_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/topics/:topic_id/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_topic_news_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/topics/:topic_id/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_topic_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/topics/:topic_id/topics/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_topic_topic_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/topics/:topic_id/topics(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_topic_topics_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/dynamic_components/topics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_dynamic_components_topics_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/events/marker_icons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_events_marker_icon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"marker_icons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/news/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_news_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/news(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_news_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/news/:news_id/related_items(.:format)
 * @param {any} news_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_news_related_items_path = /*#__PURE__*/ __jsr.r({"news_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"news_id"],[2,[7,"/"],[2,[6,"related_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/settings/additional_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_settings_additional_code_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"additional_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/settings/cookie_banner_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_settings_cookie_banner_configuration_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"cookie_banner_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/settings/cookie_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_settings_cookie_configuration_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"cookie_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/settings/header_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_settings_header_menu_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"header_menu"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/settings/public_footer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_settings_public_footer_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"public_footer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/settings/public_header(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_settings_public_header_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"public_header"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/settings/seo_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_settings_seo_configuration_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"seo_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/topics/:topic_id/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_topics_news_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/topics/:topic_id/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_topics_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/topics/:topic_id/news/:news_id/related_items(.:format)
 * @param {any} topic_id
 * @param {any} news_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_topics_news_related_items_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"news_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"news_id"],[2,[7,"/"],[2,[6,"related_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/publicoffice/users/marker_icons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_publicoffice_users_marker_icon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"marker_icons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/publish(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/publish(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/publish(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/publish(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/publish(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/query(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const query_backoffice_network_journeys_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/quick_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_search_backoffice_networks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"quick_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/quick_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_search_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"quick_search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_properties_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_routes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/unsplash/randoms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const randoms_backoffice_unsplash_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"unsplash"],[2,[7,"/"],[2,[6,"randoms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps/:id/readme_template(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const readme_template_backoffice_network_mobile_app_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"readme_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/recently_connected(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recently_connected_user_users_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"recently_connected"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_push_notifications/:id/recipients(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recipients_backoffice_network_mobile_push_notification_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_push_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recurly/notification/:webhook_token(.:format)
 * @param {any} webhook_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recurly_path = /*#__PURE__*/ __jsr.r({"webhook_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"recurly"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[3,"webhook_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:id/recurring_campaign_information(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recurring_campaign_information_backoffice_network_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recurring_campaign_information"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:id/recurring_campaign_information(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recurring_campaign_information_backoffice_network_topic_recurring_emailing_communication_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recurring_campaign_information"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mention/:id/redirect(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirect_mention_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mention"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /redis/carts/:cart_uuid(.:format)
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redis_cart_path = /*#__PURE__*/ __jsr.r({"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"redis"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /refacto-live-feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refacto_live_feed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refacto-live-feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refacto-map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refacto_map_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refacto-map"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/zendesk/sso/region_confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const region_confirm_backoffice_zendesk_sso_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"zendesk"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"region_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/zendesk/sso/region_select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const region_select_backoffice_zendesk_sso_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"zendesk"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"region_select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/registration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registration_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:id/reject(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/:id/reject(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/related_topics(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_topics_backoffice_network_recurring_emailing_communications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[6,"related_topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/related_topics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_topics_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/related_topics(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_topics_topic_event_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/invitation/remove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_backoffice_simple_admin_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/user_lists/:id/remove_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_users_private_backoffice_networks_user_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:id/renew(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renew_backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/:id/renew(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renew_backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /opportunities/:id/renew(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renew_opportunity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/business_opportunities/requests/:id/renew(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renew_topics_topic_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/requests/:id/renew(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renew_user_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/reorder(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_backoffice_network_topics_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/comments/replies(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replies_user_comments_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/report(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/report(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/report(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_backoffice_network_forums_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/report(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_backoffice_network_memberships_types_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/report(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_backoffice_network_opportunities_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/report(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/report(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_backoffice_network_topic_jobs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/report(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_backoffice_network_topic_memberships_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/homepage/reported_content_count(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reported_content_count_backoffice_network_homepage_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"homepage"],[2,[7,"/"],[2,[6,"reported_content_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/reports(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/reports(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_backoffice_network_topic_letter_emailings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/reports_export(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_export_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"reports_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/privacy_settings/request_account_deletion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_account_deletion_users_privacy_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"privacy_settings"],[2,[7,"/"],[2,[6,"request_account_deletion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/resend_all_invitations(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_all_invitations_backoffice_network_approvals_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[6,"resend_all_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/resend_campaign(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_campaign_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/resend_invitations(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_invitations_backoffice_network_admins_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"resend_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_emails/:id/resend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_user_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso_admin/reset_jwt_secret(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_jwt_secret_backoffice_network_sso_admin_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso_admin"],[2,[7,"/"],[2,[6,"reset_jwt_secret"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso/reset_jwt_secret(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_jwt_secret_backoffice_network_sso_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"reset_jwt_secret"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/carts_v2/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_order_management_carts_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/carts_v2/:id/reset(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_topic_order_management_carts_v2_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/account_details/restrict_super_admin_access(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restrict_super_admin_access_backoffice_network_account_details_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"account_details"],[2,[7,"/"],[2,[6,"restrict_super_admin_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /robots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const robots_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"robots"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const roles_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/:id/roles(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const roles_backoffice_network_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/admins/roles(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const roles_backoffice_network_admins_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/:id/roles(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const roles_backoffice_network_topic_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/roles(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const roles_backoffice_network_topic_admins_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/roles(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const roles_backoffice_network_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /saml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/save_recipient_emails(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_emails_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_recipient_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/save_recipient_emails(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_emails_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_recipient_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/save_recipient_emails(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_emails_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_recipient_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/save_recipient_emails(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_emails_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_recipient_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/save_recipient_user_lists(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_user_lists_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_recipient_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/save_recipient_user_lists(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_user_lists_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_recipient_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/save_recipient_user_lists(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_user_lists_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_recipient_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/save_recipient_user_lists(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_user_lists_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_recipient_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/save_recipient_user_lists(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_recipient_user_lists_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_recipient_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/flash_messages/campaigns/:campaign_id/recipients/save_search(.:format)
 * @param {any} network_id
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_search_backoffice_network_flash_messages_campaign_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/flash_messages/campaigns/:campaign_id/recipients/save_user_lists(.:format)
 * @param {any} network_id
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_user_lists_backoffice_network_flash_messages_campaign_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"save_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/:id/scan(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scan_backoffice_network_users_xl_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users_xls/:id/scan_errors(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scan_errors_backoffice_network_users_xl_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users_xls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"scan_errors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/schedule_campaign(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_campaign_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"schedule_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/schedule_campaign(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_campaign_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"schedule_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/schedule_campaign(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_campaign_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"schedule_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/schedule_campaign(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_campaign_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"schedule_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/schedule_for_later(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_for_later_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"schedule_for_later"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/schedule_for_later(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_for_later_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"schedule_for_later"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/schedule_for_later(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_for_later_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"schedule_for_later"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/schedule_for_later(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_for_later_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"schedule_for_later"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schools_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"schools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /search/ape_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_ape_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"ape_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/approvals/:approval_id/users/search(.:format)
 * @param {any} network_id
 * @param {any} approval_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_approval_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"approval_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"approval_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_templates/search(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_builder_templates_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_templates"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:donation_campaign_id/orders/:order_id/matchings/search(.:format)
 * @param {any} network_id
 * @param {any} donation_campaign_id
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_donation_campaign_order_matchings_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"donation_campaign_id":{"r":true},"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"donation_campaign_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"matchings"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/search(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_donation_campaigns_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/engagement_scoring/scoring_points/search(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_engagement_scoring_scoring_points_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"scoring_points"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/search(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_opportunities_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/payments/search(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/receipts/search(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_receipts_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"receipts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/roles/search(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_roles_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/scoring_points/search(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_topic_engagement_scoring_scoring_points_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"scoring_points"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/search(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_topic_jobs_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/search(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_topic_members_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/payments/search(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_topic_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/users/:user_id/payments/search(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_topic_user_payments_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/search(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_backoffice_network_users_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /search/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_countries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/customizable_attribute_select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_customizable_attribute_select_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"customizable_attribute_select"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/degrees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_degrees_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"degrees"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/field_of_studies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_field_of_studies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"field_of_studies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/media_center/search_files(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_files_backoffice_network_topic_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"search_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_filters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_filters_po_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /search/global_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_global_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"global_search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/industries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_industries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"industries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/job_functions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_job_functions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"job_functions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/nationalities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_nationalities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"nationalities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/other_infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_other_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"other_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/unsplash/search_pictures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_pictures_backoffice_unsplash_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"unsplash"],[2,[7,"/"],[2,[6,"search_pictures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/users/advanced_search/query/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_private_backoffice_networks_users_advanced_search_query_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"advanced_search"],[2,[7,"/"],[2,[6,"query"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /search/schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"schools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/skills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_skills_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"skills"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/subnetworks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_subnetworks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"subnetworks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/timezones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_timezones_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"timezones"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/search_user(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_user_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"search_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_push_notifications/search_user(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_user_backoffice_network_mobile_push_notifications_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_push_notifications"],[2,[7,"/"],[2,[6,"search_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/search_user(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_user_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"search_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/search_user(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_user_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"search_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/search_user(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_user_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"search_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/search_user(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_user_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/posts/search(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_user_posts_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/security(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"security"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/select_funds(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_funds_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_funds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/subscriptions/select_plan(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_plan_backoffice_network_billing_subscriptions_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"select_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/send_campaign(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_campaign_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:id/send_digest(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_digest_backoffice_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_digest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/network_events/:event_id/emails/:id/send_email(.:format)
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_backoffice_api_network_events_email_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"network_events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/send_email(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/send_email(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/send_email(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/send_email(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/users/:id/send_group_digest(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_group_digest_backoffice_network_user_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_group_digest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/admins/:id/send_invitation(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_invitation_backoffice_network_topic_admin_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/invitation_email(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_invitation_email_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invitation_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/updates/:id/send_mail(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_mail_backoffice_network_update_campaigns_update_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/subscriptions/:id/send_renewal_reminder(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_renewal_reminder_backoffice_network_billing_subscription_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_renewal_reminder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/update_campaigns/campaigns/:id/send_test(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_test_backoffice_network_update_campaigns_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"update_campaigns"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_push_notifications/:id/send_to(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_to_backoffice_network_mobile_push_notification_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_push_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps/:id/send_validation_request(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_validation_request_backoffice_network_mobile_app_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_validation_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/sending_summary(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sending_summary_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"sending_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/sending_summary(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sending_summary_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"sending_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/sending_summary(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sending_summary_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"sending_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/sending_summary(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sending_summary_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"sending_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/sending_summary_popup(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sending_summary_popup_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"sending_summary_popup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/sending_summary_popup(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sending_summary_popup_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"sending_summary_popup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/sending_summary_popup(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sending_summary_popup_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"sending_summary_popup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/sending_summary_popup(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sending_summary_popup_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"sending_summary_popup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/app_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_app_pages_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"app_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/colors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_colors_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"colors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/current_network(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_current_network_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"current_network"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_features_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/login_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_login_settings_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"login_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/network_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_network_configuration_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"network_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/page_customizables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_page_customizables_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/styles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_styles_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"styles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/session_info/theming(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_info_theming_donations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"theming"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id/set_groups_feed_visited(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_groups_feed_visited_user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_groups_feed_visited"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps/:id/set_status(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_status_backoffice_network_mobile_app_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_forums_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/journeys/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_journeys_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"journeys"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/media_center/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_media_center_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/scoring_points/settings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_topic_engagement_scoring_scoring_points_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"scoring_points"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/settings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_topic_events_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/settings(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_topic_news_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_topics_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ventures/settings(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_backoffice_network_ventures_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /share_content(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const share_content_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"share_content"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders/:uuid/share_to_livefeed(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const share_to_livefeed_user_portfolio_v2_folder_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"share_to_livefeed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders/:folder_uuid/files/:uuid/share_to_livefeed(.:format)
 * @param {any} user_id
 * @param {any} folder_uuid
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const share_to_livefeed_user_portfolio_v2_folder_file_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_uuid":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_uuid"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"share_to_livefeed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /articles/:articleUuid(.:format)
 * @param {any} articleUuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_article_path = /*#__PURE__*/ __jsr.r({"articleUuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"articleUuid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso_admin/show_certificate(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_certificate_backoffice_network_sso_admin_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso_admin"],[2,[7,"/"],[2,[6,"show_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso/show_certificate(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_certificate_backoffice_network_sso_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"show_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /portfolios_v2/show_file(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_file_portfolios_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"portfolios_v2"],[2,[7,"/"],[2,[6,"show_file"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /media_center/folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_media_center_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/portfolio/folders/:folderId(.:format)
 * @param {any} id
 * @param {any} folderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_portfolio_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"folderId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folderId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/forum/t/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_topic_forum_thread_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/media_center/folders/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_topic_media_center_folder_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_topic_memberships_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sign-up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/simple_create(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simple_create_backoffice_network_companies_companies_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"simple_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sitemap"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /topics/:id/sitemap(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sitemap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /universal_tags/skip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skip_universal_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"universal_tags"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/social_integrations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const social_integrations_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"social_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /celebrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_celebrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"celebrations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mentoring/:id/apply/:mentor_id/mentee(.:format)
 * @param {any} id
 * @param {any} mentor_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_mentoring_program_apply_mentee_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"mentor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[3,"mentor_id"],[2,[7,"/"],[2,[6,"mentee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentoring/:id/apply/mentee(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_mentoring_program_apply_mentee_admin_match_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[6,"mentee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentoring/:id/apply/mentor(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_mentoring_program_apply_mentor_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[6,"mentor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentoring/:id/mentors(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_mentoring_program_index_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/:id/card/mentee(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_program_mentee_profile_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"mentee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/:id/card/mentee/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_program_mentee_profile_card_edit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"mentee"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/:id/card(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_program_mentor_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_program_mentor_edit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/:id/card/mentor(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_program_mentor_profile_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"mentor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/:id/card/mentor/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_program_mentor_profile_card_edit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"mentor"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/:id/relationships/:relationship_id(.:format)
 * @param {any} id
 * @param {any} relationship_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_program_relationship_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"relationship_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[3,"relationship_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/:id/relationships(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_program_relationships_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/topics/:topic_id/:id/card/mentee(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_topics_program_mentee_profile_card_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"mentee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/topics/:topic_id/:id/card/mentee/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_topics_program_mentee_profile_card_edit_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"mentee"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/topics/:topic_id/:id/card(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_topics_program_mentor_card_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/topics/:topic_id/:id/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_topics_program_mentor_edit_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/topics/:topic_id/:id/card/mentor(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_topics_program_mentor_profile_card_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"mentor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/topics/:topic_id/:id/card/mentor/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_topics_program_mentor_profile_card_edit_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"mentor"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/topics/:topic_id/:id/relationships/:relationship_id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} relationship_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_topics_program_relationship_request_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"relationship_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[3,"relationship_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my-mentoring/topics/:topic_id/:id/relationships(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spa_my_mentoring_topics_program_relationships_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"my-mentoring"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cas/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_auth_cas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cas"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/admins/saml/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_backoffice_admins_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/super_admins/saml/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_backoffice_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cas/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_cas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cas"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jwt_auth/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_jwt_auth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jwt_auth"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth2/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_oauth2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /saml/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_saml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/engagement_scoring/scoring_points/status(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_backoffice_network_topic_engagement_scoring_scoring_points_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"engagement_scoring"],[2,[7,"/"],[2,[6,"scoring_points"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/:attachment_id(.:format)
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storage_attachment_path = /*#__PURE__*/ __jsr.r({"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /storage/new_attachment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storage_create_attachment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"new_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /storage/:attachment_id(.:format)
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storage_destroy_attachment_path = /*#__PURE__*/ __jsr.r({"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /storage/:attachment_id/download(.:format)
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storage_download_attachment_path = /*#__PURE__*/ __jsr.r({"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[3,"attachment_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/:attachment_id/virus_scan_status(.:format)
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storage_virus_scan_status_attachment_path = /*#__PURE__*/ __jsr.r({"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[3,"attachment_id"],[2,[7,"/"],[2,[6,"virus_scan_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/notification/:webhook_token(.:format)
 * @param {any} webhook_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_path = /*#__PURE__*/ __jsr.r({"webhook_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[3,"webhook_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_config_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"config"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stripe/connect/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_connect_confirm_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"connect"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/connect/deauthorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_connect_deauthorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"connect"],[2,[7,"/"],[2,[6,"deauthorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/connect/oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_connect_oauth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"connect"],[2,[7,"/"],[2,[6,"oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/setup_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_setup_intent_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"setup_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/studies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studies_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"studies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_info/styles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const styles_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"styles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/sub_networks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sub_networks_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"sub_networks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/sub_networks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sub_networks_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sub_networks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/page_customizables/:id/sub_page_to_main_page(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sub_page_to_main_page_backoffice_network_event_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sub_page_to_main_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/page_customizables/:id/sub_page_to_main_page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sub_page_to_main_page_backoffice_network_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sub_page_to_main_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/page_customizables/:id/sub_page_to_main_page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sub_page_to_main_page_backoffice_network_topic_page_customizable_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page_customizables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sub_page_to_main_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subnetworks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subnetworks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subnetworks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /universal_tags/subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_universal_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"universal_tags"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/account_details/subscription(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_backoffice_network_account_details_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"account_details"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/zendesk/sso/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_backoffice_zendesk_sso_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"zendesk"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /donations/:id/success(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_donation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/user/v3/reactions/emojis/summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_api_internal_user_v3_reactions_emojis_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"reactions"],[2,[7,"/"],[2,[6,"emojis"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/summary_ticket(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_ticket_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"summary_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/summary_ticket(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_ticket_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"summary_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/surveys(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const surveys_backoffice_network_item_urls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /surveys/forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const surveys_form_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/switch_version(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_version_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch_version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/billing/sync(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_backoffice_network_billing_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/sync_recurly(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_recurly_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_recurly"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/tabs_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tabs_settings_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tabs_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /opportunities/tag_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_options_opportunities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[6,"tag_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/business_opportunities/requests/tag_options(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_options_topic_business_opportunities_requests_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[6,"tag_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/business_opportunities/requests/tag_options(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_options_topics_topic_business_opportunities_requests_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[6,"tag_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/requests/tag_options(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_options_user_business_opportunities_requests_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[6,"tag_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/login_activities/:authenticable_type/:authenticable_id(.:format)
 * @param {any} authenticable_type
 * @param {any} authenticable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const target_status_private_backoffice_networks_login_activities_path = /*#__PURE__*/ __jsr.r({"authenticable_type":{"r":true},"authenticable_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"login_activities"],[2,[7,"/"],[2,[3,"authenticable_type"],[2,[7,"/"],[2,[3,"authenticable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/targeting_user_invitations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const targeting_user_invitations_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"targeting_user_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/members/targeting_user_invitations(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const targeting_user_invitations_backoffice_network_topic_members_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"targeting_user_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/targeting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const targeting_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"targeting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/letter_emailings/:letter_emailing_id/recipients/test_mail(.:format)
 * @param {any} network_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_mail_backoffice_network_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"test_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/test_mail(.:format)
 * @param {any} network_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_mail_backoffice_network_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"test_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/letter_emailings/:letter_emailing_id/recipients/test_mail(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} letter_emailing_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_mail_backoffice_network_topic_letter_emailing_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"letter_emailing_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[2,[7,"/"],[2,[3,"letter_emailing_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"test_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/recurring_emailing_communications/:recurring_emailing_communication_id/recipients/test_mail(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} recurring_emailing_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_mail_backoffice_network_topic_recurring_emailing_communication_recipients_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"recurring_emailing_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"recurring_emailing_communications"],[2,[7,"/"],[2,[3,"recurring_emailing_communication_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"test_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_info/theming(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const theming_session_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"theming"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/promo_codes/:id/toggle_field(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_field_backoffice_network_promo_code_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_field"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/:id/toggle_pinned(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/:id/toggle_pinned(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/companies/companies/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_companies_company_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/forums/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_forum_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/forum/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_topic_forum_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/ventures/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_topic_venture_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/ventures/:id/toggle_pinned_on_index_page(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_pinned_on_index_page_backoffice_network_venture_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_pinned_on_index_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/locations/:id/toggle_post_to_top_post(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_post_to_top_post_user_location_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_post_to_top_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/posts/:id/toggle_post_to_top_post(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_post_to_top_post_user_post_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_post_to_top_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/:id/toggle_public(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_public_backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/opportunities/:id/toggle_public(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_public_backoffice_network_opportunity_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/toggle_public(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_public_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/jobs/:id/toggle_public(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_public_backoffice_network_topic_job_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/:id/toggle_public(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_public_backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/:id/toggle_publish(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_publish_backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/toggle_publish(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_publish_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/:id/toggle_publish(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_publish_backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/toggle_suggested(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_suggested_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_suggested"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/universal_tags/tags/:id/toggle_visibility_for_users(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_visibility_for_users_backoffice_network_universal_tags_tag_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"universal_tags"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_visibility_for_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /token_update_campaigns/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const token_update_campaigns_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"token_update_campaigns"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /token_update_campaigns/updates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const token_update_campaigns_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"token_update_campaigns"],[2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /forums/discussions/top_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_categories_forums_discussions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forums"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[6,"top_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /feed_items/top_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_posts_feed_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feed_items"],[2,[7,"/"],[2,[6,"top_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/app/config(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_app_config_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"app"],[2,[7,"/"],[2,[6,"config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/braintree/to_charge(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_braintree_to_charge_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"to_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/business_opportunities/requests/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/business_opportunities/requests(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_business_opportunities_requests_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/dynamic_components/search/topic_categories(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_categories_backoffice_network_dynamic_components_search_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"topic_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:event_id/attendees(.:format)
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_create_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/jobs/:id/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_edit_opportunity_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/billing(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_billing_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/billing/donations(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_billing_donations_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_id_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/payment(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_payment_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/registration(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_registration_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/registration/donations(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_registration_donations_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/success(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_success_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/ticket-selection(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_booking_ticket_selection_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"ticket-selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_details_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/online(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_online_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"online"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/online-completed(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_online_completed_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"online-completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/registration(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_event_registration_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_events_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_events_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/feed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_feed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/forum(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_forum_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"forum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/forum/t/:id/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_forum_edit_thread_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/forum(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_forum_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"forum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/forum/t/new(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_forum_new_thread_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/home(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_home_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/home(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/opportunities(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_jobs_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/opportunities/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_jobs_show_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/letter_emailings(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_letter_emailings_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"letter_emailings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/login(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_login_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events_markers_v2(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_markers_v2_po_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events_markers_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/media_center(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_media_center_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"media_center"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/media_center/file/:uuid(.:format)
 * @param {any} topic_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_media_center_file_view_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/media_center/folder/:uuid(.:format)
 * @param {any} topic_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_media_center_folder_view_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folder"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/media_center(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_media_center_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_members_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/members(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_members_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_membership_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/:id/success(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_membership_success_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/memberships(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/order(/:id)(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_order_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/order(/:id)/billing(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_order_billing_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/order(/:id)/completed(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_order_completed_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/order/create(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_order_create_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/order(/:id)/payment(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_order_payment_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/order(/:id)/registration(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_order_registration_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/order(/:id)/success(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_memberships_order_success_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"order"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:event_id/attendees/:id(.:format)
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_attendee_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:event_id/attendees(.:format)
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/calendar(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_calendar_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/highlighted_events(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_highlighted_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"highlighted_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/page/:page_id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_page_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"page_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/payment(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_payment_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/registration(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_registration_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/related_topics(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_related_topics_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/success(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_event_success_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_network_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_new_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:event_id/attendees/new(.:format)
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_new_network_event_attendee_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/news(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_news_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/opportunities(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_opportunities_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/carts_v2/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_order_management_carts_v2_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/carts_v2/:carts_v2_id/cart_items/:id(.:format)
 * @param {any} topic_id
 * @param {any} carts_v2_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_order_management_carts_v2_cart_item_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"carts_v2_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"carts_v2_id"],[2,[7,"/"],[2,[6,"cart_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/carts_v2/:carts_v2_id/cart_items(.:format)
 * @param {any} topic_id
 * @param {any} carts_v2_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_order_management_carts_v2_cart_items_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"carts_v2_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"carts_v2_id"],[2,[7,"/"],[2,[6,"cart_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/carts_v2(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_order_management_carts_v2_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/orders/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_order_management_order_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/orders(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_order_management_orders_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/page/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_page_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:event_id/attendees/pay_later(.:format)
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_pay_later_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"pay_later"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/paypal/client_token(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_paypal_client_token_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"client_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/paypal/create_order(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_paypal_create_order_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"create_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/paypal/to_charge(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_paypal_to_charge_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"to_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/billing(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_billing_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/billing/donations(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_billing_donations_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_id_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/payment(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_payment_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/registration(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_registration_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/registration/donations(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_registration_donations_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"donations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/success(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_success_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id/booking/:cartId/ticket-selection(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} cartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_network_events_event_booking_ticket_selection_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"cartId":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"booking"],[2,[7,"/"],[2,[3,"cartId"],[2,[7,"/"],[2,[6,"ticket-selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_news_post_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/topic_feed_posts/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_po_whitelabel_topic_feed_posts_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"topic_feed_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/dynamic_components/events/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_dynamic_components_event_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/dynamic_components/events(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_dynamic_components_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/dynamic_components/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_dynamic_components_news_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/dynamic_components/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_dynamic_components_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/dynamic_components/topics/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_dynamic_components_topic_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/dynamic_components/topics(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_dynamic_components_topics_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"dynamic_components"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_news_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/private/publicoffice/news/:news_id/related_items(.:format)
 * @param {any} topic_id
 * @param {any} news_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_private_publicoffice_news_related_items_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"news_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"publicoffice"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"news_id"],[2,[7,"/"],[2,[6,"related_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_publicoffice_topics_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events_markers_v2(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_publicoffice_topics_events_markers_v2_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events_markers_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_publicoffice_topics_network_event_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/search(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_search_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/filters(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_search_filters_po_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/app_pages(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_app_pages_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"app_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/colors(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_colors_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"colors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/current_network(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_current_network_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"current_network"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/features(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_features_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/login_settings(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_login_settings_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"login_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/network_configuration(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_network_configuration_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"network_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/page_customizables(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_page_customizables_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"page_customizables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/styles(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_styles_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"styles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/session_info/theming(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_session_info_theming_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"session_info"],[2,[7,"/"],[2,[6,"theming"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/mentoring/:id/apply/:mentor_id/mentee(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {any} mentor_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_spa_mentoring_program_apply_mentee_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"mentor_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[3,"mentor_id"],[2,[7,"/"],[2,[6,"mentee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/mentoring/:id/apply/mentee(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_spa_mentoring_program_apply_mentee_admin_match_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[6,"mentee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/mentoring/:id/apply/mentor(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_spa_mentoring_program_apply_mentor_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[6,"mentor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/mentoring/:id/apply/mentor/edit(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_spa_mentoring_program_apply_mentor_edit_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[6,"mentor"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/mentoring/:id/mentors(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_spa_mentoring_program_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"mentoring"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mentors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/stripe/config(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_stripe_config_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/stripe/connect/confirm(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_stripe_connect_confirm_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"connect"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/stripe/connect/deauthorize(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_stripe_connect_deauthorize_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"connect"],[2,[7,"/"],[2,[6,"deauthorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/stripe/connect/oauth(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_stripe_connect_oauth_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"connect"],[2,[7,"/"],[2,[6,"oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/stripe/setup_intent(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_stripe_setup_intent_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"setup_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/events/:event_id/attendees/summary_ticket(.:format)
 * @param {any} topic_id
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_summary_ticket_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"summary_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/topic_feed_posts/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topic_feed_posts_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"topic_feed_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/payment_page/:cart_uuid(.:format)
 * @param {any} topic_id
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topic_payment_page_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payment_page"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/payment_page/:cart_uuid(.:format)
 * @param {any} topic_id
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topic_po_payment_page_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"payment_page"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/redis/carts/:cart_uuid(.:format)
 * @param {any} topic_id
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topic_po_redis_cart_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"redis"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/redis/carts/:cart_uuid(.:format)
 * @param {any} topic_id
 * @param {any} cart_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topic_redis_cart_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"cart_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"redis"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/filters(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topic_search_filters_po_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topics_membership_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topics_memberships_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/memberships_v2(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_topics_memberships_v2_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/touchnet/cancel(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_touchnet_cancel_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"touchnet"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/touchnet/error(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_touchnet_error_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"touchnet"],[2,[7,"/"],[2,[6,"error"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/touchnet/generate_ticket(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_touchnet_generate_ticket_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"touchnet"],[2,[7,"/"],[2,[6,"generate_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/touchnet/success(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_touchnet_success_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"touchnet"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/ventures/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_venture_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/ventures(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_ventures_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/ventures(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_ventures_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/topics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/category_sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_category_set_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/category_sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_category_sets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"category_sets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/approvals/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_approval_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/approvals(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_approvals_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/business_opportunities/requests/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/business_opportunities/requests(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_business_opportunities_requests_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/categories/:topic_category_id(.:format)
 * @param {any} topic_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_category_path = /*#__PURE__*/ __jsr.r({"topic_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"topic_category_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/events(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_events_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/feed_items(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_feed_items_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"feed_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/followings/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_following_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"followings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/followings(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_followings_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"followings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/media_center/folders/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_media_center_folder_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/media_center/folders/:folder_id/files/:id(.:format)
 * @param {any} topic_id
 * @param {any} folder_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_media_center_folder_file_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"folder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/media_center/folders/:folder_id/files(.:format)
 * @param {any} topic_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_media_center_folder_files_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/media_center/folders(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_media_center_folders_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"media_center"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/members(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_members_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/memberships_v2/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_memberships_v2_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships_v2"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/memberships_v2(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_memberships_v2_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/news/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_news_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/news(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_news_index_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/pages/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_page_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/posts/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_post_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/tags(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_tags_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/:id(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_venture_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/:venture_id/team_members/:id(.:format)
 * @param {any} topic_id
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_venture_team_member_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures/:venture_id/team_members(.:format)
 * @param {any} topic_id
 * @param {any} venture_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_venture_team_members_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"venture_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/ventures(.:format)
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topic_ventures_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics_v2/feed_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topics_v2_feed_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics_v2"],[2,[7,"/"],[2,[6,"feed_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_topics_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topics_v2_topics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /touchnet/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const touchnet_cancel_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"touchnet"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /touchnet/error(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const touchnet_error_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"touchnet"],[2,[7,"/"],[2,[6,"error"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /touchnet/generate_ticket(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const touchnet_generate_ticket_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"touchnet"],[2,[7,"/"],[2,[6,"generate_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /touchnet/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const touchnet_success_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"touchnet"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/my_memberships/:id/transactions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transactions_users_my_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"my_memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /translations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"translations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trip_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /token_update_campaigns/updates/:id/unchanged(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unchanged_token_update_campaigns_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"token_update_campaigns"],[2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unchanged"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/followings/:id/unfollow(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unfollow_topics_topic_following_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"followings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unfollow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /universal_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const universal_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"universal_tags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/unpublish(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpublish_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpublish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/unpublish(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpublish_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpublish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/admins/notifications/unread_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unread_count_private_backoffice_networks_admins_notifications_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"unread_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/unviewed(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unviewed_user_notifications_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"unviewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /articles/:articleUuid/edit(.:format)
 * @param {any} articleUuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_article_path = /*#__PURE__*/ __jsr.r({"articleUuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"articleUuid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/update_auto_approval_user_list(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_auto_approval_user_list_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_auto_approval_user_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donation_campaigns/:id/update_email(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_email_backoffice_network_donation_campaign_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donation_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:id/update_email(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_email_backoffice_network_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:id/update_email(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_email_backoffice_network_topic_event_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:id/emails(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_emails_backoffice_network_topic_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/builder_configurations/update_font(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_font_backoffice_network_builder_configurations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"builder_configurations"],[2,[7,"/"],[2,[6,"update_font"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/advanced/donations/update_headline(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_headline_backoffice_network_memberships_advanced_donations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"update_headline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/advanced/donations/update_headline(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_headline_backoffice_network_topic_memberships_advanced_donations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"advanced"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"update_headline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/memberships/types/update_membership_positions(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_membership_positions_backoffice_network_memberships_types_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"update_membership_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/memberships/update_membership_positions(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_membership_positions_backoffice_network_topic_memberships_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"update_membership_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/events/:event_id/responses/:event_response_id(.:format)
 * @param {any} network_id
 * @param {any} event_id
 * @param {any} event_response_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_participation_backoffice_network_event_responses_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"event_id":{"r":true},"event_response_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[3,"event_response_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/events/:event_id/responses/:event_response_id(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} event_id
 * @param {any} event_response_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_participation_backoffice_network_topic_event_responses_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"event_id":{"r":true},"event_response_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[3,"event_response_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id/update_photo(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_photo_user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/account_details/privacy(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_privacy_backoffice_network_account_details_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"account_details"],[2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donations/update_receipt_template(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_receipt_template_backoffice_network_donations_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"update_receipt_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/mobile_apps/:id/update_screenshots(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_screenshots_backoffice_network_mobile_app_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"mobile_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_screenshots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/topics/:topic_id/followings/:id/update_settings(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_settings_topics_topic_following_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"followings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/news/:id/update_social_media_list(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_social_media_list_backoffice_network_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_social_media_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/news/:id/update_social_media_list(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_social_media_list_backoffice_network_topic_news_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_social_media_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/update_topics_positions(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_topics_positions_backoffice_network_topics_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"update_topics_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/network_emails/:id/upload_image(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_image_backoffice_network_network_email_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"network_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/email_analytics_v2/url_links(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_links_backoffice_network_email_analytics_v2_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"email_analytics_v2"],[2,[7,"/"],[2,[6,"url_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/activity(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_activity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/approval(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_approval_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"approval"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/articles/:uuid(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_article_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/articles(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_articles_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/:provider/callback(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_authentication_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_authentication_failure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/prepare(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_authentication_prepare_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"prepare"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/badges(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_badges_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"badges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/bookmarks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_bookmarks_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/contract_types/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_contract_type_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"contract_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/contract_types(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_contract_types_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"contract_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/experience_types/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_experience_type_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"experience_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/experience_types(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_experience_types_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"experience_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/kinds/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_kind_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"kinds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/kinds(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_kinds_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"kinds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/requests/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_request_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/requests/:request_id/applicants(.:format)
 * @param {any} user_id
 * @param {any} request_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_request_applicants_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"applicants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/business_opportunities/requests(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_business_opportunities_requests_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"business_opportunities"],[2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/comments/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_comment_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/comments(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_comments_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/companies/companies(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_companies_companies_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/companies/companies/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_companies_company_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirm_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/user_customizable_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_customizable_attributes_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"user_customizable_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/user_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_data_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"user_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_events/:id/edit(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_edit_user_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/educations/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_education_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"educations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/educations(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_educations_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"educations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/events(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_events_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /feeds/:access_token/user_events(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_events_feed_path = /*#__PURE__*/ __jsr.r({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"access_token"],[2,[7,"/"],[2,[6,"user_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /feeds/:access_token/user_events/calendar(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_events_feed_calendar_path = /*#__PURE__*/ __jsr.r({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"access_token"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/sso_admin/user_exception_list(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_exception_list_backoffice_network_sso_admin_index_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"sso_admin"],[2,[7,"/"],[2,[6,"user_exception_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/experiences/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_experience_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"experiences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/experiences(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_experiences_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"experiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/external_data_imports(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_external_data_imports_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"external_data_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/flash_messages/notifications(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_flash_messages_notifications_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"flash_messages"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/industries(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_industries_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"industries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/industries/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_industry_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"industries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/job_functions/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_job_function_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"job_functions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/jwt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_jwt_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"jwt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/likes/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_like_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"likes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/likes(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_likes_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"likes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/linkedin_recommended_jobs(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_linkedin_recommended_jobs_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"linkedin_recommended_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/api/user_search/user_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_lists_backoffice_api_user_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_search"],[2,[7,"/"],[2,[6,"user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/locations/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_location_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/locations(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_locations_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/nationalities(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_nationalities_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"nationalities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_network_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/attendees(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_network_event_attendees_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/bookings(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_network_event_bookings_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_network_events_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/letters/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_network_letter_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/letters(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_network_letters_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"letters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_events/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_new_user_event_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notifications_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/portfolio(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"portfolio"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/file/:uuid(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_file_view_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/folders/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_folder_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/folders/:folder_id/files/:id(.:format)
 * @param {any} user_id
 * @param {any} folder_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_folder_file_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/folders/:folder_id/files(.:format)
 * @param {any} user_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_folder_files_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/portfolio/:uuid(.:format)
 * @param {any} id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_folder_view_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/folders(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_folders_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/new-file(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_new_file_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"new-file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/new-file/:uuid(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_new_file_subfolder_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"new-file"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/new-folder(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_new_folder_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"new-folder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio/new-folder/:uuid(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_new_folder_subfolder_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[2,[6,"new-folder"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders/:uuid(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_v2_folder_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders/:folder_uuid/files/:uuid(.:format)
 * @param {any} user_id
 * @param {any} folder_uuid
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_v2_folder_file_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_uuid":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_uuid"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders/:folder_uuid/files(.:format)
 * @param {any} user_id
 * @param {any} folder_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_v2_folder_files_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_uuid"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folder_from_file(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_v2_folder_from_file_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folder_from_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders/:folder_uuid/show_cover(.:format)
 * @param {any} user_id
 * @param {any} folder_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_v2_folder_show_cover_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"folder_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_uuid"],[2,[7,"/"],[2,[6,"show_cover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/folders(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_v2_folders_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/portfolio_v2/share_to_livefeed(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_portfolio_v2_share_to_livefeed_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"portfolio_v2"],[2,[7,"/"],[2,[6,"share_to_livefeed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/posts/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_post_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/posts(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_posts_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/profile_light(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_profile_light_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"profile_light"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sign-up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/resume(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_resume_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_invitations/user_search(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_search_user_user_invitations_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_invitations"],[2,[7,"/"],[2,[6,"user_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sign-in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/user_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_settings_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"user_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/sharing_options(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_sharing_options_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"sharing_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/signup_payments/:uuid(.:format)
 * @param {any} user_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_signup_payment_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"signup_payments"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/signup_payments(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_signup_payments_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"signup_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/similar-profiles(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_similar_profiles_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"similar-profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/skills(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_skills_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"skills"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/surveys/forms/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_surveys_form_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/trips/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_trip_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/trips(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_trips_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"trips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_v2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/users/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_user_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_invitations(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_user_invitations_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_profiles(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_user_profiles_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ventures/team_members/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_ventures_team_member_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ventures/team_members(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_ventures_team_members_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"team_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ventures/ventures/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_ventures_venture_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ventures/ventures(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_ventures_ventures_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/memberships_v2/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_memberships_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"memberships_v2"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/memberships_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_memberships_v2_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"memberships_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/my_events/:my_event_id/download_ticket(.:format)
 * @param {any} my_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_my_event_download_ticket_path = /*#__PURE__*/ __jsr.r({"my_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"my_events"],[2,[7,"/"],[2,[3,"my_event_id"],[2,[7,"/"],[2,[6,"download_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/my_memberships/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_my_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"my_memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/my_memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_my_memberships_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"my_memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/privacy_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_privacy_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"privacy_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/profile_completion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_profile_completion_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"profile_completion"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/receipts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_receipts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"receipts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_unsubscribe_v2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe_v2/one_click_unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_unsubscribe_v2_one_click_unsubscribe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_v2"],[2,[7,"/"],[2,[6,"one_click_unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/updated_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_updated_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"updated_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/topics/:topic_id/whitelabels/:id/validate(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_api_internal_admin_v4_topic_whitelabel_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/admin/v4/whitelabels/:id/validate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_api_internal_admin_v4_whitelabel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/donations/whitelabels/:id/validate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_backoffice_network_donation_whitelabel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"donations"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/topics/:topic_id/whitelabels/:id/validate(.:format)
 * @param {any} network_id
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_backoffice_network_topic_whitelabel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/whitelabels/:id/validate(.:format)
 * @param {any} network_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_backoffice_network_whitelabel_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"whitelabels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_management/carts_v2/:id/validate_promo_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_promo_code_order_management_carts_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate_promo_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:topic_id/order_management/carts_v2/:id/validate_promo_code(.:format)
 * @param {any} topic_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_promo_code_topic_order_management_carts_v2_path = /*#__PURE__*/ __jsr.r({"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"order_management"],[2,[7,"/"],[2,[6,"carts_v2"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate_promo_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /private/backoffice/networks/users/advanced_search/filters/values(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const values_private_backoffice_networks_users_advanced_search_filters_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"private"],[2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"advanced_search"],[2,[7,"/"],[2,[6,"filters"],[2,[7,"/"],[2,[6,"values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const venture_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:venture_id/funding_rounds/:id(.:format)
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const venture_funding_round_path = /*#__PURE__*/ __jsr.r({"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"funding_rounds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:venture_id/investors/:id(.:format)
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const venture_investor_path = /*#__PURE__*/ __jsr.r({"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"investors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:venture_id/locations/:id(.:format)
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const venture_location_path = /*#__PURE__*/ __jsr.r({"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:venture_id/posts/:id(.:format)
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const venture_post_path = /*#__PURE__*/ __jsr.r({"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:venture_id/posts(.:format)
 * @param {any} venture_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const venture_posts_path = /*#__PURE__*/ __jsr.r({"venture_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures/:venture_id/team_members/:id(.:format)
 * @param {any} venture_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const venture_team_member_path = /*#__PURE__*/ __jsr.r({"venture_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[2,[7,"/"],[2,[3,"venture_id"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ventures_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:network_id/item_urls/ventures(.:format)
 * @param {any} network_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ventures_backoffice_network_item_urls_path = /*#__PURE__*/ __jsr.r({"network_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"network_id"],[2,[7,"/"],[2,[6,"item_urls"],[2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /topics/:id/ventures(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ventures_topic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ventures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/viewed(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewed_user_notifications_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"viewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/visibility_opt_in(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visibility_opt_in_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"visibility_opt_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/responses/visibility_opt_in(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visibility_opt_in_user_network_event_responses_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[6,"visibility_opt_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/attendees/visibility_opt_out(.:format)
 * @param {any} event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visibility_opt_out_event_attendees_path = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[6,"visibility_opt_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/networks/events/:network_event_id/responses/visibility_opt_out(.:format)
 * @param {any} user_id
 * @param {any} network_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visibility_opt_out_user_network_event_responses_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"network_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"network_event_id"],[2,[7,"/"],[2,[6,"responses"],[2,[7,"/"],[2,[6,"visibility_opt_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/surveys/forms/:id/vote(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vote_user_surveys_form_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"vote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /votes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const votes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"votes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_engine_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"backoffice"]]);

/**
 * Generates rails route to
 * /backoffice/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_engine_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"backoffice"]],[7,"/"]],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /backoffice/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_engine_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"backoffice"]],[7,"/"]],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/welcome_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_page_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"welcome_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /backoffice/networks/:id/zoom(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zoom_backoffice_network_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"backoffice"],[2,[7,"/"],[2,[6,"networks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"zoom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /zoom/signature(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zoom_signature_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zoom"],[2,[7,"/"],[2,[6,"signature"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /zoom/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zoom_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zoom"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

